<template>
	<b-card header-tag="header" style="padding: 0; margin: 0">
		<template #header>
			<div class="d-flex justify-content-between hidden-print">
				<b-badge @click="goBack" style="padding: 10px; font-size: 15px; cursor: pointer" variant="primary"
					class="fa fa-arrow-left focus-out"><b class="ml-2">В меню</b></b-badge>
				<h5 v-for="(rate, index) in lastCurrencyRates" class="modal-title d-flex align-items-center"
					:class="index === 0 ? 'ml-1' : index === lastCurrencyRates.length - 1 ? 'mr-1' : ''"
					:key="`cbu_currency_rates-pos-top-${index}`">
					<b style="font-size: 18px">
						<span class="flag-icon flag-icon-us ml-2"></span>
						USD = <span v-if="rate.currencyCode !== 'USD'"> {{ rate.ratioToDepCurrencyRate.toFixed(2) }} {{
							rate.currencyName }}</span>
						<span v-else>{{ rate.rate.toFixed(2) }} UZS</span>
						<span v-if="rate.currencyCode === 'USD'" class="flag-icon flag-icon-uz ml-2"></span>
						<span v-else-if="rate.currencyCode === 'EUR'" class="flag-icon flag-icon-eu ml-2"></span>
						<span v-else-if="rate.currencyCode === 'RUB'" class="flag-icon flag-icon-ru ml-2"></span>
						<span v-else-if="rate.currencyCode === 'GBP'" class="flag-icon flag-icon-gb ml-2"></span>
					</b>
				</h5>
			</div>
		</template>
		<b-row>
			<b-col cols="7">
				<multiselect label="name" track-by="itemId" v-model="item" :options="whItems" :searchable="true"
					:show-labels="false" @select="changeItem" :close-on-select="true" :internal-search="false"
					@search-change="loadItems($event)" :placeholder="$t('incomes.create.product')">
					<template slot="singleLabel" slot-scope="props">
						<span>
							{{ props.option.barcode }} <b>/</b> {{ props.option.name ? props.option.name :
								props.option.itemName }} <b>/</b> {{ props.option.artikul }}
						</span>
						<span style="position: absolute; right: 25px">
							<b>{{ props.option.priceUzs }} {{ depCurrencyName }}</b>
						</span>
					</template>
					<template slot="option" slot-scope="option">
						<span>
							{{ option.option.barcode }} <b>/</b> {{ option.option.name ? option.option.name :
								option.option.itemName }} <b>/</b> {{ option.option.artikul }}
						</span>
						<span style="position: absolute; right: 25px">
							<b>{{ option.option.priceUzs }} {{ depCurrencyName }}</b>
						</span>
					</template>
				</multiselect>
			</b-col>
			<b-col>
				<b-button-group style="width: 100%">
					<multiselect track-by="id" :searchable="true" :show-labels="false" v-model="employeeId"
						:options="employees" :close-on-select="true" :internal-search="false"
						:custom-label="sellerCustomLabel" placeholder="--Выберите продавца--"
						@search-change="getEmployees($event)">
						<template slot="option" slot-scope="option">
							{{ sellerCustomLabel(option.option) }}
						</template>
					</multiselect>
					<div v-if="!skyShopSale" @click="kkmModal"
						style="position: relative; width: 50px; margin-left: 10px">
						<b-badge class="bg-primary" style="padding: 10px; position: absolute; top: -5px"><i
								style="font-size: 22px" class="fa fa-shopping-cart" /></b-badge>
						<b-badge class="bg-danger" style="position: absolute; right: -4px; top: -8px"><b-spinner
								v-model="loading" v-if="loading" type="grow" small /><span v-if="!loading">{{ count
								}}</span></b-badge>
					</div>
					<div v-if="!skyShopSale" @click="infoKkm"
						style="position: relative; width: 50px; margin-left: 10px">
						<b-badge class="bg-success" style="padding: 10px; position: absolute; top: -5px"><i
								style="font-size: 22px" class="fa fa-info-circle" /></b-badge>
						<b-badge class="bg-danger" style="position: absolute; right: -4px; top: -8px"
							v-if="loading"><b-spinner v-model="loading" type="grow" small /></b-badge>
					</div>
					<div v-if="isBar && !skyShopSale"
						@click="getGroupList(); restaurantProductModal = !restaurantProductModal"
						style="position: relative; width: 50px; margin-left: 10px">
						<b-badge class="bg-purple" style="padding: 10px; position: absolute; top: -5px"><i
								style="font-size: 22px" class="fa fa-list" /></b-badge>
						<b-badge class="bg-danger" style="position: absolute; right: -4px; top: -8px"
							v-if="loading"><b-spinner v-model="loading" type="grow" small /></b-badge>
					</div>
					<div v-else-if="isSkyShop && !skyShopSale" @click="getSkyShopList(); skyShopTable = !skyShopTable"
						style="position: relative; width: 50px; margin-left: 10px">
						<b-badge class="bg-purple" style="padding: 10px; position: absolute; top: -5px"><i
								style="font-size: 22px" class="fa fa-list" /></b-badge>
						<b-badge class="bg-danger" style="position: absolute; right: -4px; top: -8px"
							v-if="loading"><b-spinner v-model="loading" type="grow" small /></b-badge>
					</div>
					<b-badge v-else-if="isSkyShop" @click="cancelSkyDocSale" class="ml-2"
						style="padding: 10px; top: -10px"><i style="font-size: 22px"
							class="fa fa-arrow-circle-left" /></b-badge>
				</b-button-group>
			</b-col>
		</b-row>
		<div>
			<div style="border: 1px solid #6e6e6e; position: relative">
				<b-overlay :show="loading" rounded="sm">
					<div v-if="restaurantProductModal" style="min-height: 48vmin">
						<div v-if="groupOrProduct" style="padding: 10px">
							<b-card v-for="(item, index) in groupList" :key="`products1-group-${index}`"
								@click="getProductsByGroup(item)"
								style="min-width: 140px; min-height: 130px; display: inline-block; position: relative"
								class="shadow-sm mr-2" :img-src="groupPhoto(item)" img-alt="product-image"
								img-height="120px" img-width="140px">
								<b-card-text>
									<b class="text-center" style="font-size: 15px">{{ item.name }}</b><br>
								</b-card-text>
							</b-card>
						</div>
						<div v-else style="padding: 10px; position: relative">
							<b-badge @click="getGroupList"
								style="position: absolute; top: 0; left: 0; z-index: 2; font-size: 30px">
								<i class="fa fa-arrow-circle-left" />
							</b-badge>
							<b-card v-for="(item, index) in productList" :key="`products1-group-${index}`"
								:class="canSale(item) ? '' : 'bg-red'" @click="productInfoTrue(item)"
								style="min-width: 140px; min-height: 140px; display: inline-block; position: relative"
								class="shadow-sm mr-2" :img-src="groupPhoto(item)" img-alt="product-image"
								img-height="130px" img-width="140px">
								<b-card-text>
									<b style="font-size: 15px">{{ item.barcode }}</b><br>
									<span style="font-size: 14px">{{ item.name }}</span>
								</b-card-text>
								<b-badge variant="success"
									style="position: absolute; top: 0; right: -5px; font-size: 12px">
									{{ item.totalPrices }} $
								</b-badge>
							</b-card>
						</div>
					</div>
					<b-table-simple v-else-if="skyShopTable" striped hover responsive sticky-header head-variant="light"
						style="height: 48vmin">
						<b-thead>
							<b-tr>
								<b-th class="text-center" style="width: 3%">№</b-th>
								<b-th class="text-center">{{ 'Дата' }}</b-th>
								<b-th class="text-center">{{ 'Документ №' }}</b-th>
								<b-th class="text-center">{{ 'Сотрудники' }}</b-th>
								<b-th class="text-center">{{ 'Действие' }}</b-th>
							</b-tr>
						</b-thead>
						<b-tbody v-if="skyShopDocList && skyShopDocList.length > 0">
							<b-tr v-for="(doc, index) in skyShopDocList" :key="`sky-doc-${index}`">
								<b-td class="text-center" style="font-size: 16px">{{ index + 1 }}</b-td>
								<b-td class="text-center" style="font-size: 16px">{{ doc.regDate }}</b-td>
								<b-td class="text-center" style="font-size: 16px">{{ doc.regNumber }}</b-td>
								<b-td class="text-center" style="font-size: 16px">
									<div v-for="emp in doc.employeeDtos" :key="`employee-${emp.id}`">
										<b-badge variant="dark" style="font-size: 10px">{{ emp.lastName + ' ' +
											emp.firstName +
											' ' + emp.middleName }}</b-badge><br>
									</div>
								</b-td>
								<b-td class="text-center">
									<b-badge @click="viewSkyItems(doc)" style="font-size: 20px" variant="dark"
										class="mr-2"><i class="fa fa-eye" /></b-badge>
									<b-badge @click="createSkyItems(doc)" style="font-size: 20px" variant="success"><i
											class="fa fa-desktop" /></b-badge>
								</b-td>
							</b-tr>
						</b-tbody>
						<b-tbody v-else>
							<b-tr>
								<b-td class="text-center" colspan="10">{{ $t('empty') }}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
					<b-table-simple v-else hover responsive sticky-header head-variant="light" style="height: 48vmin">
						<b-thead>
							<b-tr>
								<b-th class="text-center" style="width: 3%">№</b-th>
								<b-th class="text-center">{{ $t('pos.product') }}</b-th>
								<b-th class="text-center">{{ $t('pos.qty') }}</b-th>
								<b-th class="text-center">{{ $t('incomes.create.price') }}</b-th>
								<b-th class="text-center">{{ $t('pos.sum') }}</b-th>
								<b-th class="text-center">{{ $t('pos.inventoryQty') }}</b-th>
								<b-th class="text-center" style="width: 3%"></b-th>
							</b-tr>
						</b-thead>
						<b-tbody v-if="skyShopSale">
							<b-tr>
								<b-td colspan="3" class="text-center">
									<b>Номер: {{ skyShopDoc.regNumber }}</b>
								</b-td>
								<b-td colspan="3" class="text-center">
									<b>Откуда: {{ skyShopDoc.fromDepartmentName }}</b>
								</b-td>
								<b-td />
							</b-tr>
							<b-tr>
								<b-td colspan="3" class="text-center">
									<b>Дата: {{ skyShopDoc.regDate }}</b>
								</b-td>
								<b-td colspan="2" class="text-center">
									<b>Кому: </b>
								</b-td>
								<b-td>
									<multiselect v-model="skyShopDoc.brigadeId" track-by="id" :searchable="true"
										:show-labels="false" :options="skyShopDoc.brigadeDtos" :close-on-select="true"
										:internal-search="false" :custom-label="sellerSkyCustomLabel"
										:placeholder="`-- Выберите бригаду --`">
										<template slot="option" slot-scope="option">
											{{ sellerSkyCustomLabel(option.option) }}
										</template>
									</multiselect>
								</b-td>
								<b-td />
							</b-tr>
						</b-tbody>
						<b-tbody>
							<b-tr v-for="(item, index) in items" :key="`pos-items-${index}`"
								:class="item._rowVariant === 'primary' ? 'bg-light-blue' : ''">
								<b-td style="font-size: 16px" @click="rowSelect(item, index)" class="text-center">{{
									index + 1
								}}</b-td>
								<b-td style="font-size: 16px" @click="rowSelect(item, index)" class="text-left"><b>{{
									item.barcode }} / {{ item.name }}</b></b-td>
								<b-td style="width: 15%" @click="rowSelect(item, index)" class="text-center">
									<!--<b-form-spinbutton v-model="item.count" @input="inputCustom($event, item)" step="any" @click="rowSelect(item, index)" :min="1" :max="item.qty" style="height: 100%; font-size: 18px; font-weight: bold" class="countInput"/>-->
									<b-button-group>
										<b-badge @click="editCount('-', item)"
											style="font-size: 18px; padding: 6px 10px 6px 10px; border-radius: 10px 0 0 10px"
											class="focus-out bg-primary"><i class="fa fa-minus" /></b-badge>
										<b-badge
											style="font-size: 18px; padding: 6px 20px 6px 20px; font-weight: bold; border-radius: 0"
											class="focus-out bg-white">{{ item.count.toFixed(3) }}</b-badge>
										<b-badge @click="editCount('+', item)"
											style="font-size: 18px; padding: 6px 10px 6px 10px; border-radius: 0 10px 10px 0"
											class="focus-out bg-primary"><i class="fa fa-plus" /></b-badge>
									</b-button-group>
								</b-td>
								<b-td style="font-size: 16px" @click="rowSelect(item, index)" class="text-center"><b>{{
									(item.discountPriceUzs ? item.discountPriceUzs : item.priceUzs).toFixed(2)
								}}</b></b-td>
								<b-td style="font-size: 16px" @click="rowSelect(item, index)" class="text-center">{{
									(item.count
										* (item.discountPriceUzs ? item.discountPriceUzs : item.priceUzs)).toFixed(2)
								}}</b-td>
								<b-td style="font-size: 16px" @click="rowSelect(item, index)" class="text-center">{{
									item.qty
								}}</b-td>
								<b-td class="text-center">
									<b-badge style="font-size: 22px" @click="removeLocalItem(index, item)"
										variant="danger"><i class="fa fa-trash" /></b-badge>
								</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-overlay>
			</div>
			<b-row class="mb-2">
				<b-col cols="4">
					<div class="view-calculator">
						<b-form-input v-model="stringCount" type="number" style="width: 80%" size="lg" />
					</div>
					<div class="calculator">
						<b-row>
							<b-col>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('1')"
									class="mr-2 mt-2 focus-out">1</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('2')"
									class="mr-2 mt-2 focus-out">2</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('3')"
									class="mr-2 mt-2 focus-out">3</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('c')"
									variant="danger" class="mr-2 mt-2 focus-out">C</b-badge>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('4')"
									class="mr-2 mt-2 focus-out">4</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('5')"
									class="mr-2 mt-2 focus-out">5</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('6')"
									class="mr-2 mt-2 focus-out">6</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('0')"
									class="mr-2 mt-2 focus-out">0</b-badge>
							</b-col>
						</b-row>
						<b-row>
							<b-col>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('7')"
									class="mr-2 mt-2 focus-out">7</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('8')"
									class="mr-2 mt-2 focus-out">8</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('9')"
									class="mr-2 mt-2 focus-out">9</b-badge>
								<b-badge style="font-size: 30px; padding: 12px 18px 12px 18px" @click="reCount('v')"
									variant="success" class="mr-1 mt-2 focus-out"><i class="fa fa-check" /></b-badge>
							</b-col>
						</b-row>
					</div>
				</b-col>
				<b-col class="pt-2">
					<b-row>
						<b-col style="font-size: 24px">
							<b>Всего :</b>
						</b-col>
					</b-row>
					<b-row>
						<b-col>
							<div style="font-size: 24px">
								<b>
									<span class="flag-icon flag-icon-us"></span>
									<span class="ml-1"> USD = {{ finalTotalSum.toFixed(2) }}</span>
								</b>
							</div>
						</b-col>
					</b-row>
					<b-row v-for="(rate, index) in lastCurrencyRates" :key="`final-total-currency-${index}`">
						<b-col>
							<div style="font-size: 24px">
								<b>
									<span v-if="rate.currencyCode === 'USD'" class="flag-icon flag-icon-uz"></span>
									<span v-else-if="rate.currencyCode === 'EUR'" class="flag-icon flag-icon-eu"></span>
									<span v-else-if="rate.currencyCode === 'RUB'" class="flag-icon flag-icon-ru"></span>
									<span v-else-if="rate.currencyCode === 'GBP'" class="flag-icon flag-icon-gb"></span>
									<span v-else-if="rate.currencyCode === 'UZS'" class="flag-icon flag-icon-uz"></span>
									<!--							CURRENCY NAME								-->
									<span v-if="rate.currencyCode !== 'USD'" class="ml-1">
										{{ rate.currencyName }} = <b>{{ (finalTotalSum *
											rate.ratioToDepCurrencyRate).toFixed(2)
										}}</b>
									</span>
									<span v-else class="ml-1">
										UZS = <b>{{ roundUZS(finalTotalSum * rate.rate) == '50' ? '0.00' :
											roundUZS(finalTotalSum * rate.rate).toFixed(2) }}</b>
									</span>
								</b>
							</div>
						</b-col>
					</b-row>
				</b-col>
				<b-col cols="4">
					<b-row class="mt-2">
						<b-col>
							<b-row class="mt-4">

							</b-row>
							<b-row class="mt-5">
								<b-col>
									<b style="font-size: 30px">Кол-во:{{ finalCount }}</b>
								</b-col>
							</b-row>
						</b-col>
						<b-col align="right">
							<b-badge @click="removeAllItems" class="focus-out" style="padding: 18px; font-size: 20px">
								<i style="font-size: 30px" class="fa fa-close text-danger mb-3" /><br>
								<b>Очистить</b>
							</b-badge>
						</b-col>
					</b-row>
					<b-row class="mt-3">
						<b-col align="right">
							<b-badge @click="payModal" class="focus-out" style="padding: 18px; font-size: 20px">
								<i style="font-size: 30px" class="fa fa-print text-success mb-3" /><br>
								<b>ОПЛАТА</b>
							</b-badge>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
		</div>
		<!-- SkyShop Doc Items Info MODAL -->
		<b-modal v-model="viewItemsSkyModal" size="xl" hide-footer>
			<b-row>
				<b-col>
					<table style="width: 100%">
						<tr>
							<td>Номер:</td>
							<td><b>{{ skyShopDoc.regNumber }}</b></td>
							<td>Откуда:</td>
							<td><b>{{ skyShopDoc.fromDepartmentName }}</b></td>
						</tr>
						<tr>
							<td>Дата:</td>
							<td><b>{{ skyShopDoc.regDate }}</b></td>
							<td>Кому:</td>
							<td>
								<div v-for="(emp, index) in skyShopDoc.brigadeDtos" :key="`emp-${index}`">
									<b>{{ emp.name + ` -- ${getEmployeeFullName(emp)}` }}</b><br>
								</div>
							</td>
						</tr>
					</table>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col>
					<b-table-simple striped hover responsive sticky-header>
						<b-thead>
							<b-tr>
								<b-th class="text-center">{{ '№' }}</b-th>
								<b-th class="text-center">{{ 'Спец-код' }}</b-th>
								<b-th class="text-center">{{ 'Продукт' }}</b-th>
								<b-th class="text-center">{{ 'Количество' }}</b-th>
								<b-th class="text-center">{{ 'Цена (штук)' }}</b-th>
								<b-th class="text-center">{{ 'Сумма (Цена)' }}</b-th>
							</b-tr>
						</b-thead>
						<b-tbody>
							<b-tr v-for="(item, index) in viewSkyDocItems" :key="`items-${index}`">
								<b-td class="text-center">{{ index + 1 }}</b-td>
								<b-td class="text-center">{{ item.barcode }}</b-td>
								<b-td class="text-center">{{ item.itemName }}</b-td>
								<b-td class="text-center">{{ item.count }}</b-td>
								<b-td class="text-center">{{ item.priceUzs }}</b-td>
								<b-td class="text-center">{{ (item.count ? item.count : 0) * item.priceUzs }}</b-td>
							</b-tr>
							<b-tr>
								<b-td colspan="5" class="text-right"><b>Итого</b></b-td>
								<b-td class="text-center">{{ sumPriceCount }}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
			</b-row>
		</b-modal>

		<!-- Product Info MODAL -->
		<b-modal v-model="productInfoModal" size="xl" style="z-index: 100" hide-footer>
			<template #modal-title>
				<b>{{ product.barcode }} </b> / <span> {{ product.name }}</span>
			</template>
			<div>
				<b-row>
					<b-col>
						<img :src="groupPhoto(product)" alt="info-product" width="100%" height="300px">
					</b-col>
					<b-col style="padding: 5px">
						<div v-for="(item, index) in product.whItems" :key="`product-items-${index}`"
							:class="index % 2 ? 'bg-grey' : ''" class="text-center" style="border: 1px solid #d7d7d7">
							<div :class="item.qty ? '' : 'bg-red'">
								<b>{{ index + 1 }} : </b> <b> {{ item.barcode }} </b> / <span> {{ item.name }}</span>
								<br>
								<b-badge>Остатка : <b>{{ item.qty ? item.qty : 0 }}</b></b-badge> / <b-badge>Цена за ед.
									: <b>{{
										item.priceUzs ? item.priceUzs : 0 }}</b></b-badge>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row>
					<b-col align="right">
						<b-badge @click="addProduct" v-if="canSale(product)" style="font-size: 20px"
							variant="primary">Добавить</b-badge>
					</b-col>
				</b-row>
			</div>
		</b-modal>

		<!-- KKM Sale-list MODAL -->
		<b-modal v-model="kkmSale" size="xl" title="Не распечатанные продажи" hide-footer>
			<table class="b-table table-hover table-striped table-bordered" style="width: 100%">
				<thead>
					<tr>
						<th class="text-center">№</th>
						<th class="text-center">Номер чека</th>
						<th class="text-center">Дата продажи</th>
						<th class="text-center">Отдел</th>
						<th class="text-center">POS №</th>
						<th class="text-center">Кол-во товаров</th>
						<th class="text-center">Сумма</th>
						<th class="text-center">Сумма со скидкой</th>
						<th class="text-center">Оплата</th>
						<th class="text-center">Действие</th>
					</tr>
				</thead>
				<tbody v-if="!loading">
					<tr v-for="(item, index) in kkmSaleList" :key="`kkm-sale-${index}`">
						<td class="text-center">{{ paginate(index, search.page, search.limit) }}</td>
						<td class="text-center">{{ item.saleNumber }}</td>
						<td class="text-center">{{ item.saleDate }}</td>
						<td class="text-center">{{ item.shopName }}</td>
						<td class="text-center">{{ item.cashboxName }}</td>
						<td class="text-center">{{ item.saleItems.length + item.productItems.length }}</td>
						<td class="text-center">{{ item.amountOfPaymentUzs | currency({
							symbol: '', fractionCount: 2,
							symbolPosition: 'back'
						}) }}</td>
						<td class="text-center">{{ item.amountOfAfterPromoUzs | currency({
							symbol: '', fractionCount: 2,
							symbolPosition: 'back'
						}) }}</td>
						<td class="text-center">
							<strong v-for="(i, ind) in item.paymentMap.CASH" :key="`cash-${ind}`">{{ i.value }}
								{{ i.currencyCode }}<br></strong>
							<strong v-for="(it, inde) in item.paymentMap.BANK_CARD" :key="`bank-${inde}`">
								<p style="color: #4DBD74">{{ it.paymentTypeCode }}</p> {{ it.value }}
								{{ it.currencyCode }}<br>
							</strong>
						</td>
						<td class="text-center">
							<b-badge @click="successKKM(item)" class="bg-success" style="margin-left: 8px"><i
									style="font-size: 20px; margin: 5px" class="fa fa-print" /></b-badge>
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr>
						<td colspan="10" class="text-center">
							<b-spinner v-show="loading" />
						</td>
					</tr>
				</tbody>
			</table>
			<nav class="text-center mt-2">
				<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="search.limit"
					:current-page.sync="search.page" />
				<!--<b-btn @click="sendAllSales" variant="success" class="float-right">Отправить все чеки</b-btn>-->
			</nav>
		</b-modal>

		<!-- Z-REPORT OPEN MODAL -->
		<b-modal size="md" hide-footer v-model="sessionStart" id="sessionStart" :no-close-on-esc="true"
			:no-close-on-backdrop="true">
			<div slot="modal-header" class="d-flex justify-content-start align-items-center">
				<b-link to="/point-of-sale/before-pos" variant="outline-dark" class="mr-3" v-b-tooltip.hover
					:title="$t('sidebar.dashboard')">
					<i class="fa fa-home" style="font-size: 18px;"></i>
				</b-link>
				<h1 class="modal-title">{{ $t('session-start') }}: {{ $t('roles.code') }} 12345</h1>
			</div>
			<b-overlay :show="loading" rounded="sm">
				<b-form-group :label="$t('roles.code')" label-for="name-input">
					<b-form-input ref="enterConfirmCode" autofocus size="md" autocomplete="off"
						class="form-control mousetrap ui-autocomplete-input" id="name-input" v-model="zCode" required />
				</b-form-group>
				<b-button class="focus-out" block size="lg" variant="primary" type="submit"
					@click="checkZReport">Ok</b-button>
			</b-overlay>
		</b-modal>

		<!-- NEW-MULTIPLE PAY MODAL -->
		<b-modal v-model="paymentModal" id="posPaymentModal" hide-footer hide-header :no-close-on-esc="true"
			:no-close-on-backdrop="true">
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col>
						<div style="font-size: 20px; font-weight: bold" class="text-center">Наличные деньги</div>
						<hr>
						<div v-for="(payment, i) in paymentCurrencyTypes" :key="`pay-${i}`" class="row">
							<div v-if="payment.left" class="col-12">
								<div class="row mt-4">
									<div class="col-6">
										<img v-if="payment.code === 'EUR'" :src="`${publicPath}img/eunion.png`"
											alt="euro flag" style="width: 30px">
										<span v-else style="font-size: 20px"
											:class="`flag-icon ${payment.code === 'USD' ? 'flag-icon-us' : payment.code === 'UZS' ? 'flag-icon-uz' : payment.code === 'RUB' ? 'flag-icon-ru' : payment.code === 'GBP' ? 'flag-icon-gb' : ''}`" />
										<b style="font-size: 20px" v-if="payment.code === 'UZS'">
											<span class="ml-2">{{ payment.code + ' = ' + (roundUZS(payment.rate *
												checkTotalSum)
												=== 50 ? '0.00' : roundUZS(payment.rate * checkTotalSum).toFixed(2))
											}}</span>
										</b>
										<b style="font-size: 20px" v-else>
											<span class="ml-2">{{ payment.code + ' = ' + (payment.rate *
												checkTotalSum).toFixed(2) }}</span>
										</b>
									</div>
									<div class="col-6">
										<b-button-group style="border-radius: 40px;">
											<b-badge :disabled="disabled" @click="setAllCash(payment)"
												style="font-size: 25px; padding: 12px"><span
													class="fa fa-check-circle text-success" /></b-badge>
											<b-badge :disabled="disabled" @click="calculatePayModal(payment, i)"
												style="font-size: 20px; padding: 12px 15px">{{ payment.value
												}}</b-badge>
											<b-badge :disabled="disabled" @click="clearCash(payment)"
												style="font-size: 25px; padding: 12px"><span
													class="mdi mdi-close-circle fa fa-close text-danger" /></b-badge>
										</b-button-group>
									</div>
								</div>
							</div>
						</div>
					</b-col>
					<b-col v-if="!skyShopSale">
						<div style="font-size: 20px; font-weight: bold" class="text-center">Банковская карта</div>
						<hr>
						<div v-for="(payment, i) in paymentCurrencyTypes" :key="`pay1-${i}`" class="row">
							<div v-if="!payment.left" class="col-12">
								<div class="row mt-4">
									<div class="col-6">
										<img v-if="payment.paymentTypeCode === 'VISA'"
											:src="`${publicPath}img/pos-images/visa_card.png`" alt="visa png"
											style="width: 40px">
										<img v-else-if="payment.paymentTypeCode === 'HUMO'"
											:src="`${publicPath}img/pos-images/humo_card.png`" alt="humo png"
											style="width: 40px">
										<img v-else-if="payment.paymentTypeCode === 'UZCARD'"
											:src="`${publicPath}img/pos-images/uzcard.png`" alt="uzcard png"
											style="width: 45px">
										<img v-else-if="payment.paymentTypeCode === 'CLICK'"
											:src="`${publicPath}img/pos-images/click.png`" alt="click png"
											style="width: 35px">
										<img v-else-if="payment.paymentTypeCode === 'UZUM'"
											:src="`${publicPath}img/pos-images/uzum.png`" alt="uzum png"
											style="width: 35px">
										<img v-else-if="payment.paymentTypeCode === 'OSON'"
											:src="`${publicPath}img/pos-images/oson.png`" alt="oson png"
											style="width: 35px">
										<img v-else-if="payment.paymentTypeCode === 'ONE_QR'"
											:src="`${publicPath}img/pos-images/one_qr.png`" alt="one_qr png"
											style="width: 35px">
										<img v-else-if="payment.paymentTypeCode === 'PAYME'"
											:src="`${publicPath}img/pos-images/payme.png`" alt="payme png"
											style="width: 35px">
										<b style="font-size: 20px" v-if="payment.paymentTypeCode === 'VISA'">
											<span class="ml-2">{{ 'USD' + ' = ' + (payment.rate *
												checkTotalSum).toFixed(2)
											}}</span>
										</b>
										<b style="font-size: 20px" v-else>
											<span class="ml-2">{{ 'UZS' + ' = ' + (roundUZS(payment.rate *
												checkTotalSum) === 50
												? '0.00' : roundUZS(payment.rate * checkTotalSum).toFixed(2)) }}</span>
										</b>
									</div>
									<div class="col-6">
										<b-button-group style="border-radius: 40px;">
											<b-badge :disabled="disabled" @click="setCash(payment)"
												style="font-size: 25px; padding: 12px"><span
													class="fa fa-check-circle text-success" /></b-badge>
											<b-badge :disabled="disabled" @click="calculatePayModal(payment, i)"
												style="font-size: 20px; padding: 12px 15px">{{ payment.value
												}}</b-badge>
											<b-badge :disabled="disabled" @click="clearCash(payment)"
												style="font-size: 25px; padding: 12px" padding="0" dense><span
													class="mdi mdi-close-circle fa fa-close text-danger" /></b-badge>
										</b-button-group>
									</div>
								</div>
							</div>
						</div>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col v-if="$can('passport', 'info')">
						<b-badge class="badge-btn" @click="identityCard" variant="success">Идентификация</b-badge>
					</b-col>
					<b-col v-if="!saleForm.isDipShop">
						<b-input v-model="saleForm.ticket" required placeholder="Билет" />
					</b-col>
					<b-col v-if="!saleForm.isDipShop">
						<b-input v-model="saleForm.flight" placeholder="Полет" />
					</b-col>
					<b-col v-if="saleForm.isDipShop">
						<b-input v-model="saleForm.numberCard" placeholder="Номер карточки" />
					</b-col>
					<b-col>
						<b-input v-model="saleForm.comment" placeholder="Примечание к оплате" />
					</b-col>

				</b-row>
				<hr class="mt-4 mb-3">
				<b-row>
					<b-col>
						<b-badge v-if="!kkmBtn" class="badge-btn" @click="closePaymentModal"
							variant="danger">Отмена</b-badge>
					</b-col>
					<b-col align="right">
						<b-badge v-if="kkmBtn" class="badge-btn" @click="successKKM(null)" variant="primary">Повторно
							отправить
							к ККМ</b-badge>
						<b-badge v-else class="badge-btn" @click="showLoaderForSaveSale" variant="success"
							:disabled="disabled">Завершить оплату</b-badge>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>

		<!-- Calculate -->
		<b-modal v-model="calculate" size="sm" centered hide-header hide-footer>
			<b-row>
				<b-col align="center">
					<b-input v-model="calculateCount" />
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col align="center">
					<b-button @click="calculateCount += '1'" variant="primary" size="lg"
						style="font-size: 30px">1</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '2'" variant="primary" size="lg"
						style="font-size: 30px">2</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '3'" variant="primary" size="lg"
						style="font-size: 30px">3</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col align="center">
					<b-button @click="calculateCount += '4'" variant="primary" size="lg"
						style="font-size: 30px">4</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '5'" variant="primary" size="lg"
						style="font-size: 30px">5</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '6'" variant="primary" size="lg"
						style="font-size: 30px">6</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col align="center">
					<b-button @click="calculateCount += '7'" variant="primary" size="lg"
						style="font-size: 30px">7</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '8'" variant="primary" size="lg"
						style="font-size: 30px">8</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '9'" variant="primary" size="lg"
						style="font-size: 30px">9</b-button>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col align="center">
					<b-button @click="calculateCount += '.'" variant="primary" size="lg"
						style="font-size: 30px">.</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount += '0'" variant="primary" size="lg"
						style="font-size: 30px">0</b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculateCount = calculateCount.substring(0, calculateCount.length - 1)"
						variant="danger" size="lg" style="font-size: 30px"><i class="fa fa-arrow-left" /></b-button>
				</b-col>
			</b-row>
			<b-row class="mt-3">
				<b-col align="center">
					<b-button @click="calculateCount = ''" variant="danger" size="lg" style="font-size: 30px"><i
							class="fa fa-close" /></b-button>
				</b-col>
				<b-col align="center">
					<b-button @click="calculatePay" variant="success" size="lg" style="font-size: 30px"><i
							class="fa fa-check" /></b-button>
				</b-col>
			</b-row>
		</b-modal>

		<!-- Sale Confirm Modal -->
		<b-modal v-model="identityModal" size="xl" title="Идентификатор" centered hide-footer no-close-on-backdrop
			no-close-on-esc>
			<b-overlay :show="loading" rounded="xl">
				<b-row>
					<b-col cols="1"></b-col>
					<b-col cols="6">
						<b-row>
							<b-col>
								<b> Фамилия</b>
							</b-col>
							<b-col><span>{{ identityList.surname }}</span></b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b>Имя</b>
							</b-col>
							<b-col><span>{{ identityList.name }}</span></b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b>Дата рождения</b>
							</b-col>
							<b-col><span>{{ identityList.dateOfBirth }}</span></b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b>ПИНФЛ</b>
							</b-col>
							<b-col><span>{{ identityList.personalNumber }}</span></b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b>Серия паспорт</b>
							</b-col>
							<b-col><span>{{ identityList.documentNumber }}</span></b-col>
						</b-row>
						<hr>
						<b-row>
							<b-col>
								<b>Код страны</b>
							</b-col>
							<b-col><span>{{ identityList.countryCode }}</span></b-col>
						</b-row>
					</b-col>
					<b-col cols="4">
						<img :src="`data:image/jpeg;base64,${identityImg}`" width="200px" height="auto">
					</b-col>
					<b-col></b-col>
				</b-row>
				<hr>
				<b-row>
					<b-col style="padding-left: 68px">
						<b-badge class="badge-btn" @click="identitClose" variant="danger">Очистить</b-badge>
					</b-col>
					<b-col align="right" style="padding-right: 78px">
						<b-badge class="badge-btn" @click="identityModal = false" variant="success"
							style="margin-left: -30px">Подтвердить</b-badge>
					</b-col>
				</b-row>
			</b-overlay>
		</b-modal>

		<b-modal size="md" hide-footer v-model="sessionStart" id="sessionStart" :no-close-on-esc="true"
			:no-close-on-backdrop="true">
			<div slot="modal-header" class="d-flex justify-content-start align-items-center">
				<b-link to="/point-of-sale/before-pos" variant="outline-dark" class="mr-3" v-b-tooltip.hover
					:title="$t('sidebar.dashboard')">
					<i class="fa fa-home" style="font-size: 18px;"></i>
				</b-link>
				<h1 class="modal-title">{{ $t('session-start') }}: {{ $t('roles.code') }} 12345</h1>
			</div>
			<b-overlay :show="loading" rounded="sm">
				<b-form-group :label="$t('roles.code')" label-for="name-input">
					<b-form-input ref="enterConfirmCode" autofocus size="md" autocomplete="off"
						class="form-control mousetrap ui-autocomplete-input" id="name-input" v-model="zCode" required />
				</b-form-group>
				<b-button class="focus-out" block size="lg" variant="primary" type="submit"
					@click="checkZReport">Ok</b-button>
			</b-overlay>
		</b-modal>

		<b-modal no-close-on-backdrop no-close-on-esc size="sm" centered hide-footer hide-header
			v-model="paymentPendingModal">
			<b-overlay rounded="sm" class="text-center">
				<div style="height: 50px">
					<span class="loader"></span>
				</div>
				<div style="font-size: 20px; font-weight: 600"
					class="d-flex flex-column justify-content-center align-items-center mt-4">
					<span v-if="!loading && ['UZCARD', 'HUMO'].includes(paymentWithQrCode)">
						ОЖИДАЕТСЯ ОПЛАТА
					</span>
					<span v-else-if="!loading">
						ОТСКАНИРУЙТЕ QR-КОД ДЛЯ СНЯТИЯ СРЕДСТВ
					</span>
				</div>
				<b-button v-if="!loading" class="focus-out mt-4" size="lg" variant="danger" type="submit"
					@click="cancelPay">
					Отменить оплату
				</b-button>
			</b-overlay>
		</b-modal>

		<b-modal size="sm" centered hide-footer hide-header v-model="paymentSuccessModal">
			<b-overlay rounded="sm" class="text-center">
				<div v-if="paymentTypeInSuccessModal !== 'ONE_QR'" style="height: 50px">
					<img style="height: 50px;" src="../../../../public/img/checked.png">
				</div>

				<div style="font-size: 20px; font-weight: 600"
					class="d-flex flex-column justify-content-center align-items-center mt-4">
					<span v-if="paymentTypeInSuccessModal === 'ONE_QR'">
						Пожалуйста, отсканируйте QR-код для снятия средств!
					</span>
					<span v-else>
						Средства успешно сняты!
					</span>
				</div>

				<b-button v-if="paymentTypeInSuccessModal==='ONE_QR'" class="focus-out mt-4" size="lg" variant="success" type="submit"
					@click="checkOneQrStatus" :disabled="loading">
					Проверить
					<span v-if="loading" class="spinner-border spinner-border-sm ml-2"></span>
				</b-button>
				<b-button v-else class="focus-out mt-4" size="lg" variant="success" type="submit"
					@click="paymentTypeInSuccessModal = ''; paymentSuccessModal = false">
					Закрыть
				</b-button>
			</b-overlay>
		</b-modal>

		<b-modal centered v-model="confirmModal" hide-header @ok="setAllCash(payItem)" @cancel="cancelConfirm"
			ok-title="Да" cancel-title="Отмена">
			<h4>Вы выбрали оплату через <span class="text-danger" style="font-weight: 600;">{{ payItem.paymentTypeCode
			}}</span>. Вы уверены, что хотите продолжить?</h4>
		</b-modal>

		<b-modal centered v-model="paymentCancelConfirmModal" hide-header @ok="closePaymentModal"
			@cancel="paymentCancelConfirmModal = false" ok-title="Да" cancel-title="Отмена">
			<h4>При отмене вы можете потерять данные об оплате. Вы уверены, что хотите продолжить?</h4>
		</b-modal>

	</b-card>
</template>

<script>
import Multiselect from 'vue-multiselect'
import CurrencyService from "../../../services/currency.service";
import PosService from "../../../services/pos.service";
import EmployeeSerive from "../../../services/employees.service";
import { mapActions, mapGetters, mapState } from "vuex";
import ZetReportService from "../../../services/zet-report.service";
import { TokenService } from "../../../services/storage.service";
import axios from "axios";
import FBoxService from "../../../services/fbox.service";
import MultiplePay from '../../point-of-sale/pos/components/MultiplePayment/MultiplePay'
import Vue from "vue";
import { BFormSpinbutton, BTableSimple, BTbody, BTd, BTh, BThead, BTr } from 'bootstrap-vue';
import { BOverlay } from 'bootstrapVue2';
import { Pagination } from 'element-ui'
import groupService from "../../restaurant/service/group.service";
import ProductService from "../../restaurant/service/product.service";
import SkyShopService from "../../sky-shop/skyshop.service";

export default {
	name: "pos",
	components: { Multiselect, MultiplePay, BFormSpinbutton, BTableSimple, BThead, BTr, BTh, BTbody, BTd, BOverlay, "b-pagination-new": Pagination },
	data() {
		return {
			isNew: localStorage.getItem('is_new'),
			extraInfo: null,
			payItem: {},
			confirmModal: false,
			paymentSuccessModal: false,
			paymentWithQrCode: false,
			paymentPendingModal: false,
			confirmModal: false,
			paymentCancelConfirmModal: false,
			saleConfirmModal: false,
			identityModal: false,
			identityImg: null,
			identityList: {},
			lastCurrencyRates: [],
			publicPath: process.env.BASE_URL,
			item: null,
			selectedItem: null,
			selectedItemIndex: null,
			whItems: [],
			multiPays: [],
			employeeId: null,
			employees: [],
			sessionStart: false,
			zCode: null,
			seller: {},
			saleForm: {},
			openClicked: false,
			saleFinishLoading: false,
			saleError: false,
			saleErrorMessage: '',
			value: 2,
			products: [],
			stringCount: '',
			finalTotalSum: 0,
			finalCount: 0,
			realTotalSum: 0,
			checkTotalSum: 0,
			totalCount: 0,
			loading: false,
			kkmBtn: false,
			disabled: false,
			paymentModal: false,
			paymentCurrencyTypes: [],
			calculateCount: '',
			calculate: false,
			dataForKKM: null,
			kkmDateTime: null,
			dateTime: null,
			kkmSale: false,
			kkmSaleList: [],
			total: null,
			count: 0,
			search: {
				page: 1,
				limit: 20
			},
			groupList: [],
			productList: [],
			productItems: [],
			items: [],
			skyShopDocList: [],
			productInfoModal: false,
			restaurantProductModal: false,
			groupOrProduct: true,
			skyShopTable: false,
			skyShopSale: false,
			product: {},
			skyShopDoc: {},
			viewSkyDocItems: [],
			viewItemsSkyModal: false,
			paymentTypeInSuccessModal: ''
		}
	},
	computed: {
		...mapGetters("employees", ["getSellers"]),
		...mapState("pos", ["amountOfPaymentUzs", "amountOfAfterPromoUzs", "saleFinishError"]),
		depCurrencyName() {
			return TokenService.getDepCurrencyName();
		},
		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		},
		isBar() {
			let tmp = localStorage.getItem('is_bar')
			if (tmp && tmp !== 'undefined')
				tmp = JSON.parse(tmp)
			else
				tmp = false
			return tmp
		},
		isSkyShop() {
			let tmp = localStorage.getItem('is_sky_shop')
			if (tmp && tmp !== 'undefined')
				tmp = JSON.parse(tmp)
			else
				tmp = false
			return tmp
		},
		sumPriceCount() {
			if (this.viewSkyDocItems && this.viewSkyDocItems.length > 0) {
				let sum = 0
				this.viewSkyDocItems.forEach(t => {
					if (t.count)
						sum += (t.count * t.priceUzs)
				})
				return sum
			} else {
				return 0
			}
		}
	},
	watch: {
		'search.page': {
			handler() {
				this.getKkmSaleList();
			}
		}
	},
	methods: {
		...mapActions("pos", ["saleFinish"]),
		cancelConfirm() {
			this.payItem = {}
			this.confirmModal = false
		},
		cancelPay() {
			this.paymentCurrencyTypes = this.paymentCurrencyTypes.map(item => {
				if (item.paymentTypeCode === this.paymentWithQrCode) {
					this.checkTotalSum = this.checkTotalSum + (item.value / item.rate)

					return { ...item, value: 0 }
				} else {
					return item
				}
			})

			this.loading = false
			this.paymentWithQrCode = false
			this.paymentPendingModal = false
		},
		async checkOneQrStatus() {
			try {
				this.loading = true
				console.log(this.extraInfo);
				const { data: response } = await FBoxService.checkOneQrStatusPay(this.extraInfo.invoice_id)
				console.log(response);
				if (response.is_success) {
					this.paymentTypeInSuccessModal = ''
					this.paymentSuccessModal = false
				} else {
					this.$bvModal.msgBoxOk(response.error.message)
				}
			} catch (error) {
				let e = JSON.parse(error.request.response)
				this.$bvModal.msgBoxOk(e.message || e.error.message || 'Tekshiruvda xatolik!', {
					size: 'md',
					centered: true,
					hideHeader: true,
					noCloseOnEsc: true,
					okVariant: 'dager',
					noCloseOnBackdrop: true,
					footerClass: 'bg-dager',
					bodyClass: 'bg-dager h3 bold'
				}).then(value => {
				})
			} finally {
				this.loading = false
			}
		},
		async paymentAction(paymentData, barcodeNumber = undefined) {
			try {
				this.barcodeDestroy()
				this.loading = true

				const payload = {
					// amount: paymentData.paymentTypeCode === 'UZUM' ? 500 : 100,
					amount: paymentData.value,
					qr_code: barcodeNumber
				}
				if (paymentData.paymentTypeCode == 'ONE_QR') {
					payload.external_id = this.saleForm.id
					payload.print = true
					payload.banner = [
						{
							type: 'text',
							data: "DutyFree",
							style: { align: 'center', is_bold: true }
						},
						{
							type: 'text',
							data: `${paymentData.value}`,
							style: { align: 'center', is_bold: false }
						}
					]
				}

				const { data: response } = await FBoxService.paymentWithQr(localStorage.getItem('ip_address'), payload, paymentData.paymentTypeCode)

				if (response) {
					this.barcodeDestroy()
					this.extraInfo = barcodeNumber ? { data: response } : response
					this.paymentPendingModal = false
					this.paymentTypeInSuccessModal = paymentData.paymentTypeCode
					this.paymentSuccessModal = true
				}
			} catch (error) {
				console.log(error)

				this.loading = false
				this.kkmBtn = false
				this.paymentPendingModal = false

				this.paymentCurrencyTypes = this.paymentCurrencyTypes.map(item => {
					if (item.paymentTypeCode === paymentData.paymentTypeCode) {
						this.checkTotalSum = this.checkTotalSum + (item.value / item.rate)

						return { ...item, value: 0 }
					} else {
						return item
					}
				})

				if (error.request && error.request.response && error.request.response !== "") {
					this.$bvModal.msgBoxOk(JSON.parse(error.request.response).message, {
						size: 'md',
						centered: true,
						hideHeader: true,
						noCloseOnEsc: true,
						okVariant: 'dager',
						noCloseOnBackdrop: true,
						footerClass: 'bg-dager',
						bodyClass: 'bg-dager h3 bold'
					}).then(value => {
					})
				} else {
					this.$bvModal.msgBoxOk(error.message, {
						size: 'md',
						centered: true,
						hideHeader: true,
						noCloseOnEsc: true,
						okVariant: 'dager',
						noCloseOnBackdrop: true,
						footerClass: 'bg-dager',
						bodyClass: 'bg-dager h3 bold'
					}).then(value => {
					})
				}
			} finally {
				this.loading = false
			}
		},
		goBack() {
			this.$router.push(`/point-of-sale/before-pos`);
		},
		paginate(index, page_size, page_number) {
			--page_size;
			return (page_number * page_size) + index + 1;
		},
		getEmployeeFullName(brigade) {
			let name = ''
			brigade.employeeDtos.forEach(t => {
				name += ` ${t.lastName} ${t.firstName} ${t.middleName}`
			})
			return name;
		},
		identitClose() {
			this.identityList = {}
			this.identityImg = null
			this.identityModal = false
		},
		async identityCard() {
			this.loading = true
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=8').then(res => {
				this.identityList.surname = res.data
				if (this.identityList.surname === null) {
					this.loading = false
					this.$vs.notify({
						text: 'Повторно введите свой идентификатор',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					text: 'Повторно введите свой идентификатор',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=9').then(res => {
				this.identityList.name = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=5').then(res => {
				this.identityList.dateOfBirth = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=12').then(res => {
				this.identityList.sex = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=7').then(res => {
				this.identityList.personalNumber = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=1').then(res => {
				this.identityList.countryCode = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetTextFieldByType?AType=2').then(res => {
				this.identityList.documentNumber = res.data
			})
			await axios.get('http://localhost:5001/Regula.SDK.Api/Methods/GetRFIDGraphicsBitmapByFieldType?AType=201').then(res => {
				this.identityImg = res.data
			})
			if (this.identityList.countryCode && this.identityList.documentNumber) {
				this.loading = false
				this.identityModal = true
			}
			else {
				this.loading = false
			}
		},
		inputCustom(v, item) {
			this.$set(item, "count", v)
			this.$forceUpdate()
			let sum = 0,
				fin = 0,
				cont = 0;
			this.products.forEach(t => {
				sum += (t.count * t.priceUzs)
				fin += (t.count * t.discountPriceUzs)
				cont += t.count
			})
			this.realTotalSum = sum
			this.finalTotalSum = fin
			this.finalCount = cont
			let co = 0
			this.products.forEach(t => {
				co += t.count
			})
			this.totalCount = co
			this.$forceUpdate()
		},
		editCount(action, item) {
			if (action === '-') {
				let sum = item.count - 1
				if (sum > 0)
					item.count = sum
				else
					this.$vs.notify({
						text: 'Количество не может быть меньше чем 1',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
			} else if (action === '+') {
				let sum = item.count + 1
				if (sum <= item.qty)
					item.count = sum
				else
					this.$vs.notify({
						text: `Количество не может быть больше чем ${item.qty}`,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
			}
			this.$forceUpdate()
			let sum = 0,
				fin = 0,
				cont = 0;
			this.items.forEach(t => {
				sum += (t.count * t.priceUzs)
				fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
				cont += t.count
			})
			this.realTotalSum = sum
			this.finalTotalSum = fin
			this.finalCount = cont
			this.$forceUpdate()
		},
		roundUZS(sum) {
			let v = Math.floor(sum % 100);
			if (v > 50) {
				return (Math.floor(sum / 100) + 1) * 100;
			} else {
				if (sum === 0) {
					return 0;
				} else if (v === 0) {
					return sum;
				} else {
					return Math.floor(sum / 100) * 100 + 50;
				}
			}
		},
		loadItems(event) {
			if (!this.skyShopSale) {
				if (event.length > 3) {
					this.loading = true
					PosService.fetchPosSearchItems1(localStorage.getItem('dep_id'), event).then(async res => {
						this.whItems = res.data
						this.loading = false
					}).catch(er => {
						this.loading = false
						this.$vs.notify({
							title: er.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
			} else {
				if (event !== '') {
					this.whItems = this.viewSkyDocItems.filter((item) => {
						if (item.barcode.toLowerCase().indexOf(event.toLowerCase()) >= 0)
							return item.barcode.toLowerCase().indexOf(event.toLowerCase()) >= 0
						else if (item.itemName.toLowerCase().indexOf(event.toLowerCase()) >= 0)
							return item.itemName.toLowerCase().indexOf(event.toLowerCase()) >= 0
					});
				} else {
					this.whItems = this.viewSkyDocItems
				}
			}
		},
		changeItem($event) {
			if (!this.restaurantProductModal) {
				let bool = false,
					item = {},
					index = null,
					itemItem = {},
					itemIndex = null;
				if (this.items.length > 0) {
					this.products.forEach((t, i) => {
						if (t.itemId === $event.itemId && t.priceUzs === $event.priceUzs) {
							bool = true
							item = t
							index = i
						}
					})
					this.items.forEach((t, i) => {
						if (t.itemId === $event.itemId && t.priceUzs === $event.priceUzs) {
							itemItem = t
							itemIndex = i
						}
						t._rowVariant = ''
					})
				}
				if (bool) {
					this.products.splice(index, 1)
					this.items.splice(itemIndex, 1)
					itemItem._rowVariant = 'primary'
					this.products.unshift(item)
					this.items.unshift(item)
					this.selectedItem = item
					this.selectedItemIndex = 0
				} else {
					if ($event.multiBarcodes[0]) {
						$event.multiBarcode = $event.multiBarcodes[0].barcode !== '' ? $event.multiBarcodes[0] : {}
					} else {
						$event.multiBarcode = {}
					}
					if ($event.promotions && $event.promotions.length > 0) {
						if ($event.promotions.length === 1) {
							if ($event.promotions[0].promotionType === '%')
								$event.discountPriceUzs = $event.priceUzs * (1 - $event.promotions[0].discount / 100)
							else
								$event.discountPriceUzs = $event.priceUzs - $event.promotions[0].discount
						} else
							$event.discountPriceUzs = $event.priceUzs * (1 - $event.promotions[0].discount / 100) - $event.promotions[1].discount
					} else {
						$event.promotions = [{ promotionType: "%", discount: 0 }, { promotionType: "PUL", discount: 0 }]
						$event.discountPriceUzs = $event.priceUzs
					}
					$event.currentDiscounts = []
					$event.customPromotion = {}
					$event.isOptom = false
					if (this.skyShopSale) {
						$event.qty = $event.whRemaining
						$event.name = $event.itemName
					}
					$event.count = $event.multiBarcode ? ($event.multiBarcode.ratio ? $event.multiBarcode.ratio : 1) : 1
					$event._rowVariant = 'primary'
					if ($event.count > $event.qty)
						$event.count = $event.qty
					this.products.unshift($event)
					this.items.unshift($event)
					this.selectedItem = $event
					this.selectedItemIndex = 0
				}
				this.item = null
				this.$forceUpdate();
				let sum = 0,
					fin = 0,
					cont = 0;
				this.items.forEach(t => {
					sum += (t.count * t.priceUzs)
					fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
					cont += t.count
				})
				this.realTotalSum = sum
				this.finalTotalSum = fin
				this.finalCount = cont
				this.$forceUpdate()
			}
		},
		getKkmSaleList() {
			this.loading = true
			PosService.getKkmSaleList(localStorage.getItem('dep_id'), localStorage.getItem('cash_id'), this.search).then(res => {
				this.kkmSaleList = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getKkmSaleCount() {
			this.loading = true
			PosService.getKkmSaleCount(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(res => {
				this.count = res.data
				this.loading = false
			}).catch(er => {
				this.loading = false
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getEmployees(search) {
			EmployeeSerive.getSellers(search).then(res => {
				this.employees = res.data
				this.employees.forEach(t => {
					if (t.isUserEmployee) {
						this.seller = t
						this.employeeId = t
					}
				})
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		sellerCustomLabel(seller) {
			return (
				seller.firstName +
				" " +
				seller.lastName
				// ' - "' +
				// seller.departmentName +
				// '"'
			);
		},
		sellerSkyCustomLabel(seller) {
			let fullNames = ''
			if (seller.employeeDtos && seller.employeeDtos.length > 0) {
				seller.employeeDtos.forEach(emp => {
					fullNames += ` ${emp.lastName} ${emp.firstName} ${emp.middleName} / `
				})
			}
			return (`${seller.name} -- ${fullNames}`);
		},
		createSale() {
			this.getKkmSaleCount();
			PosService.createSaleDraftService(this.seller, localStorage.getItem('cash_id'), localStorage.getItem('dep_id')).then(res => {
				this.kkmBtn = false
				this.saleForm = res.data
			}).catch(er => {
				const error = JSON.parse(er.request.response);
				if (error.message === 'Company uchun seans mavjud emas, iltimos, komanya uchun seans oching' || error.code == 400) {
					this.sessionStart = true
				}
			})
		},
		rowSelect(item, index) {
			this.items.forEach(t => {
				t._rowVariant = ''
			})
			this.selectedItem = item
			this.selectedItemIndex = index
			this.items[index]._rowVariant = 'primary'
			this.item = null
			this.$forceUpdate()
		},
		removeLocalItem(index, item) {
			this.items.splice(index, 1);
			let ind = null
			if (item.isBar) {
				this.productItems.forEach((t, i) => {
					if (t.productId === item.productId)
						ind = i
				})
				this.productItems.splice(ind, 1);
			} else {
				this.products.forEach((t, i) => {
					if (t.itemId === item.itemId)
						ind = i
				})
				this.products.splice(ind, 1);
			}
			if (this.items.length > 0) {
				this.items.forEach(t => {
					t._rowVariant = ''
				})
				this.selectedItem = this.items[0]
				this.selectedItemIndex = 0
				this.items[0]._rowVariant = 'primary'
				this.item = null
			}
			let sum = 0,
				fin = 0,
				cont = 0;
			this.items.forEach(t => {
				sum += (t.count * t.priceUzs)
				fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
				cont += t.count
			})
			this.realTotalSum = sum
			this.finalTotalSum = fin
			this.finalCount = cont
			this.$forceUpdate()
		},
		removeAllItems() {
			this.items = []
			this.products = []
			this.productItems = []
			this.realTotalSum = 0
			this.finalTotalSum = 0
			this.$forceUpdate()
		},
		reCount(count) {
			if (this.selectedItem) {
				if (count === 'c')
					this.stringCount = ''
				else if (count === 'v') {
					if (this.selectedItem.isBar) {
						let index1 = null
						this.productItems.forEach((t, i) => {
							if (this.items[this.selectedItemIndex].productId === t.productId)
								index1 = i
						})
						if (index1) {
							if (parseFloat(this.stringCount) > this.productItems[index1].qty) {
								this.productItems[index1].count = this.productItems[index1].qty
							} else {
								this.productItems[index1].count = parseFloat(this.stringCount)
							}
						}
					} else {
						let index = null
						this.products.forEach((t, i) => {
							if (this.items[this.selectedItemIndex].itemId === t.itemId)
								index = i
						})
						if (index) {
							if (parseFloat(this.stringCount) > this.products[index].qty) {
								this.products[index].count = this.products[index].qty
							} else {
								this.products[index].count = parseFloat(this.stringCount)
							}
						}
					}
					if (parseFloat(this.stringCount) > this.items[this.selectedItemIndex].qty) {
						this.items[this.selectedItemIndex].count = this.items[this.selectedItemIndex].qty
					} else {
						this.items[this.selectedItemIndex].count = parseFloat(this.stringCount)
					}
					this.stringCount = ''
				} else
					this.stringCount += count
				this.$forceUpdate();
				let sum = 0,
					fin = 0,
					cont = 0;
				this.items.forEach(t => {
					sum += (t.count * t.priceUzs)
					fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
					cont += t.count
				})
				this.realTotalSum = sum
				this.finalTotalSum = fin
				this.finalCount = cont
				this.$forceUpdate()
			} else {
				this.$vs.notify({
					title: 'Сначала выберите товар',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		convertRuToEn(input) {
			const ru = 'ёйцукенгшщзхъфывапролджэячсмитьбю.';
			const en = '`qwertyuiop[]asdfghjkl;\'zxcvbnm,/.';

			return input.split('').map(char => {
				const index = ru.indexOf(char.toLowerCase());
				if (index === -1) return char;

				const newChar = en[index];
				return char === char.toUpperCase() ? newChar.toUpperCase() : newChar;
			}).join('');
		},
		posBarcodeScanned(barcodeNumberProps) {
			let barcodeNumber = this.convertRuToEn(barcodeNumberProps)

			if (this.paymentModal) {
				const paymentData = this.paymentCurrencyTypes.find(foo => foo.value && ['CLICK', 'PAYME', 'UZUM'].includes(foo.paymentTypeCode))

				if (paymentData) {
					this.paymentAction(paymentData, barcodeNumber)
				}
			}

			if (this.loading === false && !this.restaurantProductModal && !this.skyShopSale) {
				this.loading = true
				PosService.fetchPosSearchItems(localStorage.getItem('dep_id'), barcodeNumber).then(res => {
					if (res.data.length > 0) {
						let bool = false,
							item = {},
							index = null,
							indexItem = null;
						this.items.forEach((t, i) => {
							if (t.itemId) {
								if (t.itemId === res.data[0].itemId && t.priceUzs === res.data[0].priceUzs) {
									indexItem = i
								}
							}
							if (t._rowVariant)
								t._rowVariant = ''
						})
						this.products.forEach((t, i) => {
							if (t.itemId === res.data[0].itemId && t.priceUzs === res.data[0].priceUzs) {
								bool = true
								item = t
								index = i
							}
						})
						if (bool) {
							this.products.splice(index, 1)
							this.items.splice(indexItem, 1)
							this.selectedItemIndex = indexItem
							this.selectedItem = item
							// 2 marta skaner
							let sum = res.data[0].multiBarcode ? (res.data[0].multiBarcode.ratio ? (item.count + res.data[0].multiBarcode.ratio) : (item.count + 1)) : item.count + 1
							if (sum <= item.qty) {
								item.count = sum
							} else {
								this.$vs.notify({
									title: `Количество товаров не должен быть больше чем - ${item.qty}`,
									color: 'warning',
									icon: 'close',
									position: 'top-right'
								});
							}
							this.products.unshift(item)
							this.items.unshift(item)
							this.items[0]._rowVariant = 'primary'
						} else {
							this.selectedItem = res.data[0]
							this.selectedItem.multiBarcode = res.data[0].multiBarcode
							if (this.selectedItem.promotions.length > 0) {
								if (this.selectedItem.promotions.length === 1) {
									if (this.selectedItem.promotions[0].promotionType === '%')
										this.selectedItem.discountPriceUzs = this.selectedItem.priceUzs * (1 - this.selectedItem.promotions[0].discount / 100)
									else
										this.selectedItem.discountPriceUzs = this.selectedItem.priceUzs - this.selectedItem.promotions[0].discount
								} else
									this.selectedItem.discountPriceUzs = this.selectedItem.priceUzs * (1 - this.selectedItem.promotions[0].discount / 100) - this.selectedItem.promotions[1].discount
							} else {
								this.selectedItem.promotions = [{
									promotionType: "%",
									discount: 0
								}, { promotionType: "PUL", discount: 0 }]
								this.selectedItem.discountPriceUzs = this.selectedItem.priceUzs
							}
							this.selectedItem.currentDiscounts = []
							this.selectedItem.customPromotion = {}
							this.selectedItem.isOptom = false
							this.selectedItem.count = res.data[0].multiBarcode.ratio ? res.data[0].multiBarcode.ratio : 1
							this.selectedItem._rowVariant = 'primary'
							this.products.unshift(this.selectedItem)
							this.items.unshift(this.selectedItem)
							this.selectedItemIndex = 0
						}
						this.item = null
						let sum = 0,
							fin = 0,
							cont = 0;
						this.items.forEach(t => {
							sum += (t.count * t.priceUzs)
							fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
							cont += t.count
						})
						this.realTotalSum = sum
						this.finalTotalSum = fin
						this.finalCount = cont
						this.$forceUpdate();
					} else {
						this.barcodeDestroy();
						this.$bvModal.msgBoxOk(`Товар не найден`, {
							size: 'sm',
							centered: true,
							hideHeader: true,
							noCloseOnEsc: true,
							okVariant: 'success',
							noCloseOnBackdrop: true,
							footerClass: 'bg-danger',
							bodyClass: 'bg-danger h3 bold'
						}).then(value => {
							this.barcodeInit()
						})
					}
					this.loading = false
				}).catch(er => {
					this.$vs.notify({
						title: er.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
					this.loading = false
				})
			}
		},
		checkZReport() {
			this.loading = true
			ZetReportService.checkOpenZReport(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(async (res) => {
				if (res.data === '1') {
					if (this.zCode == '12345') {
						await this.sessionStartOk();
					} else {
						this.zCode = null
						this.$vs.notify({
							title: 'Code => 12345',
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					}
				}
				this.loading = false
			}).catch(e => {
				this.$vs.notify({
					title: e.response.data.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
				this.loading = false
			})
		},
		async sessionStartOk() {
			await FBoxService.zReportOpen(localStorage.getItem('ip_address')).then(res => {
				if (res.data.is_success || res.data.error.message === 'ERROR_ZREPORT_IS_ALREADY_OPEN') {
					ZetReportService.openSession(localStorage.getItem('dep_id'), localStorage.getItem('cash_id')).then(fisRes => {
						this.sessionStart = false
						this.createSale();
					}).catch(er => {
						this.$vs.notify({
							title: er.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.$vs.notify({
						title: res.data.error ? res.data.error.message : 'KKM не работает',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				}
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		closePayment() {
			this.openClicked = false;
			this.$refs.multiPayModal.hide()
			this.$store.commit('pos/setPosDisabled', false);
			this.$store.commit('pos/setSaleFinishError', { message: '', boolean: false });
			if (this.kkmBtn)
				this.removeAllItems();
		},
		closePaymentModal() {
			this.barcodeInit();
			this.paymentModal = false
		},
		getOutOfStockError() {
			let error = false;
			for (let item of this.products) {
				if (item.count > item.qty && !item._rowVariant) {
					error = true;
					break;
				}
			}
			return error;
		},
		getPriceChanged() {
			let payload = {
				boolean: false,
				indexes: []
			}
			for (let i = 0; i < this.products.length; i++) {
				if (this.products[i].priceChanged) {
					Vue.set(this.products[i], '_rowVariant', { priceUzs: 'warning' })
					payload.boolean = true;
					payload.indexes.push(i + 1);
				}
			}
			return payload;
		},
		multiplePaymentModal() {
			if (this.products.length > 0) {
				let hasOutOfStockItem = this.getOutOfStockError();
				let booleanAndIndexes = this.getPriceChanged();
				if (hasOutOfStockItem) {
					this.$vs.notify({
						title: 'Пожалуйста, проверьте количество продуктов',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				} else if (booleanAndIndexes.boolean) {
					let stringIndexes = booleanAndIndexes.indexes.join(', ');
					this.$vs.notify({
						title: `Проверьте эти товары №: "${stringIndexes}"`,
						text: 'если цена была изменена, то удалите и добавьте снова',
						time: 6500,
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				} else {
					this.getCurrencyRates();
					this.openClicked = true;
					// this.$refs.multiplePayRef.reorderAndAddCurrencies()
					this.$refs.multiPayModal.show()
				}
			} else {
				this.openClicked = false;
				this.$vs.notify({
					title: 'Пожалуйста, добавьте продукт',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
			}
		},
		async sendAllSales() {
			await this.kkmSaleList.forEach(sale => {
				FBoxService.orderCreate(localStorage.getItem('ip_address'), JSON.parse(sale.kkmData), sale.id).then(async (fisRes) => {
					if (fisRes.data.is_success) {
						this.$vs.notify({
							time: 1000,
							title: 'Продажа выполнена успешно!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						this.item = {}
						this.whItems = []
						this.products = []
						this.item = null
						this.createSale();
						this.openClicked = false;
						this.loading = false
					} else {
						this.loading = false
						this.kkmBtn = false
						this.$vs.notify({
							title: fisRes.data.error.message,
							color: 'danger',
							icon: 'close',
							time: 50000,
							position: 'top-right'
						})
						return 0;
					}
				}).catch(e => {
					this.loading = false
					this.kkmBtn = false
					if (e.request && e.request.response && e.request.response !== "") {
						let error = JSON.parse(e.request.response)
						this.$vs.notify({
							title: error.message || error.error.message,
							icon: 'close',
							color: 'danger',
							position: 'top-right'
						})
					} else {
						this.$vs.notify({
							title: e.message,
							icon: 'close',
							color: 'danger',
							position: 'top-right'
						})
					}
					return 0;
				})
			})
			this.getKkmSaleList();
			this.getKkmSaleCount();
		},
		async successKKM(item) {
			if (item) {
				this.dataForKKM = {}
				this.dataForKKM.data = JSON.parse(item.kkmData)
				this.dataForKKM.saleId = item.id
			}
			this.loading = true
			if (this.dataForKKM) {
				const payload = {
					...this.dataForKKM.data,

					extra_info: this.extraInfo
				}
				await FBoxService.orderCreate(localStorage.getItem('ip_address'), payload, this.dataForKKM.saleId).then(async (fisRes) => {
					if (fisRes.data.is_success) {
						// if (item && item.warehouseDocumentId)
						// 	this.saveSkyDoc(item.warehouseDocumentId)
						// else if (this.skyShopDoc)
						// 	this.saveSkyDoc(this.skyShopDoc.id)
						this.$vs.notify({
							time: 1000,
							title: 'Продажа выполнена успешно!',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
						if (this.skyShopSale)
							this.cancelSkyDocSale();
						this.createSale();
						this.item = {}
						this.whItems = []
						this.items = []
						this.products = []
						this.productItems = []
						this.item = null
						this.realTotalSum = 0
						this.finalTotalSum = 0
						this.finalCount = 0
						this.checkTotalSum = 0
						this.kkmBtn = false
						this.kkmData = null
						this.disabled = false
						this.paymentModal = false
						this.dataForKKM = null
						this.kkmBtn = false
						this.getKkmSaleCount();
						if (item)
							this.getKkmSaleList();
						this.kkmSale = false
						this.loading = false
					} else {
						this.loading = false
						if (!item)
							this.kkmBtn = true
						this.$vs.notify({
							title: fisRes.data.error.message === 'ERROR_RECEIPT_MEMORY_FULL' ? 'Отправьте на сервер файлы чеков, получить RECEIPT_ACK и выполнить  INS_ASK_RECEIPT. Обращаться ККМщикам' :
								fisRes.data.error.message === 'ERROR_NOT_ENOUGH_CASH_FOR_REFUND' ||
									fisRes.data.error.message === 'ERROR_NOT_ENOUGH_CARD_FOR_REFUND' ||
									fisRes.data.error.message === 'ERROR_NOT_ENOUGH_VAT_FOR_REFUND' ? 'Не достаточно денег на кассе для возврата чека, попробуйте позже' :
									fisRes.data.error.message === 'ERROR_RECEIPT_CASH_OVERFLOW' ||
										fisRes.data.error.message === 'ERROR_RECEIPT_CARD_OVERFLOW' ||
										fisRes.data.error.message === 'ERROR_RECEIPT_COUNT_OVERFLOW' ||
										fisRes.data.error.message === 'ERROR_RECEIPT_VAT_OVERFLOW' ? 'Текущий Z-отчет переполнен операциями. Закройте и откройте Z-отчет и повторите попытку' :
										fisRes.data.error.message === 'ERROR_RECEIPT_STORE_DAYS_LIMIT_EXCEEDED' ? 'В ККМ имеются неотправленные чеки.' :
											fisRes.data.error.message === 'ERROR_RECEIPT_SEQ_OVERFLOW' ||
												fisRes.data.error.message === 'ERROR_NOT_INTIALIZED' ||
												fisRes.data.error.message === 'ERROR_ZREPORT_SPACE_IS_FULL' ||
												fisRes.data.error.message === 'ERROR_LOCKED_FOREVER' ? 'Сдать ККМ и получить новый' :
												fisRes.data.error.message === 'ERROR_RECEIPT_TIME_PAST' ||
													fisRes.data.error.message === 'ERROR_OPEN_ZREPORT_TIME_PAST' ||
													fisRes.data.error.message === 'ERROR_CLOSE_ZREPORT_TIME_PAST' ? 'Исправьте дату и время на моноблоке' :
													fisRes.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
														fisRes.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
														fisRes.data.error.message === 'ERROR_FRIST_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
														fisRes.data.error.message === 'ERROR_LAST_TRANSACTION_TIME_FORMAT_INVALID' ||
														fisRes.data.error.message === 'ERROR_ZREPORT_PARTITION_INVALID' ||
														fisRes.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
														fisRes.data.error.message === 'ERROR_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
														fisRes.data.error.message === 'ERROR_RECEIPT_PARTITION_INVALID' ? 'Возможно ККМ поврежден. Обратиться к ККМщикам. Сдать ККМ и получить новый' :
														fisRes.data.error.message === 'ERROR_ZREPORT_IS_ALREADY_OPEN' ? 'Z-отчет открыт. Обратиться к программистам' :
															fisRes.data.error.message === 'ERROR_RECEIPT_FORMAT_INVALID' ||
																fisRes.data.error.message === 'ERROR_OPEN_CLOSE_ZREPORT_WRONG_LENGTH' ||
																fisRes.data.error.message === 'ERROR_CURRENT_TIME_FORMAT_INVALID' ||
																fisRes.data.error.message === 'ERROR_LOCK_CHELLENGE_INVALID' ||
																fisRes.data.error.message === 'ERROR_DATA_SIZE_NOT_SUPPORTED' ||
																fisRes.data.error.message === 'ERROR_ACKNOWLEGE_WRONG_LENGTH' ||
																fisRes.data.error.message === 'ERROR_ZREPORT_INDEX_OUT_OF_BOUNDS' ||
																fisRes.data.error.message === 'ERROR_ACKNOWLEGE_TERMINAL_ID_MIS_MATCH' ||
																fisRes.data.error.message === 'ERROR_ACKNOWLEGE_SIGNATURE_INVALID' ||
																fisRes.data.error.message === 'SW_COMMAND_NOT_ALLOWED' ||
																fisRes.data.error.message === 'ERROR_CONFIGURE_SIGNATURE_INVALID' ||
																fisRes.data.error.message === 'ERROR_CONFIGURE_WRONG_LENGHT' ||
																fisRes.data.error.message === 'SW_WRONG_P1P2' ||
																fisRes.data.error.message === 'ERROR_RECEIPT_INDEX_OUT_OF_BOUNDS' ? 'Проверить Кассовое ПО на ошибки, исправить их и повторить попытку. Обратиться к ККМщикам' :
																fisRes.data.error.message === 'ERROR_ZREPORT_IS_NOT_OPEN' ||
																	fisRes.data.error.message === 'ERROR_CURRENT_ZREPORT_IS_EMPTY' ||
																	fisRes.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
																	fisRes.data.error.message === 'ERROR_RECEIPT_COUNT_ZERO' ? 'Проблема в Z - отчете' :
																	fisRes.data.error.message,
							color: 'danger',
							icon: 'close',
							time: 50000,
							position: 'top-right'
						})
					}
				}).catch(e => {
					this.loading = false
					if (!item)
						this.kkmBtn = true
					this.loading = false
					if (e.request && e.request.response && e.request.response !== "") {
						let error = JSON.parse(e.request.response)
						this.$vs.notify({
							title: error.message || error.error.message,
							icon: 'close',
							color: 'danger',
							position: 'top-right'
						})
					} else {
						this.$vs.notify({
							title: e.message,
							icon: 'close',
							color: 'danger',
							position: 'top-right'
						})
					}
				})
			}
		},
		async successMultiPay(isCheck, paymentMethods, totalPaid, debtPaymentAmount, returnItemsCount, returnItemsSum, sponsorshipAmount) {
			this.loading = true
			this.returnMoney = 0;
			this.returnItemsCount = returnItemsCount;
			this.returnItemsSum = returnItemsSum;
			this.sponsorshipAmount = sponsorshipAmount;
			this.totalPaid = totalPaid;
			this.multiPays = paymentMethods;
			this.debtPayment = debtPaymentAmount;
			await this.savePos();
			this.loading = false
		},
		makeCurrentDateTime(forMethod) {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = '0' + month;
			}
			if (day.toString().length == 1) {
				day = '0' + day;
			}
			if (hour.toString().length == 1) {
				hour = '0' + hour;
			}
			if (minute.toString().length == 1) {
				minute = '0' + minute;
			}
			if (second.toString().length == 1) {
				second = '0' + second;
			}
			if (forMethod == 'savePos') {
				return month + '-' + day + '-' + year;
			}
			this.dateTime = year + '/' + month + '/' + day + ' ' + hour + ':' + minute + ':' + second;
			this.kkmDateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
		},
		async savePos() {
			if (this.employeeId) {
				if (this.products.length > 0) {
					let data = {
						id: this.saleForm.id,
						action: this.saleForm.action,
						saleDate: this.makeCurrentDateTime('savePos'),
						saleNumber: this.saleForm.saleNumber,
						cashboxId: localStorage.getItem('cash_id'),
						cashboxNumber: localStorage.getItem('cash_number'),
						sellerId: this.employeeId.id,
						shopId: localStorage.getItem('dep_id'),
						cashierFullName: `${this.employeeId.firstName} ${this.employeeId.lastName}`,
						customPromotion: null,
						finalTotalSum: this.finalTotalSum,
						realTotalSum: this.realTotalSum,
						amountOfPaymentUzs: this.realTotalSum,
						amountOfAfterPromoUzs: this.finalTotalSum,
						payments: this.multiPays ? this.multiPays : null,
						saleItems: this.products,
						passportInfoDto: this.identityList && this.identityList.name ? this.identityList : null,
						productItems: this.productItems,
						currencyRateDtos: this.lastCurrencyRates,
						comment: this.$refs.multiplePayRef.paymentComment,
						flight: this.$refs.multiplePayRef.flight,
						numberCard: this.$refs.multiplePayRef.numberCard,
						ticket: this.$refs.multiplePayRef.ticket
					}
					// await ApiService.post('sale/get/soliq/order-create', data).then(async (res) => {
					// 	if (res.data.fiscalServiceCheckObject === true) {
					await PosService.finishSale(data).then(async (res) => {
						if (res.data) {
							const payload = {
								...res.data,

								extra_info: this.extraInfo
							}
							await FBoxService.orderCreate(localStorage.getItem('ip_address'), payload, res.data.saleId).then(async (fisRes) => {
								if (fisRes.data.is_success) {
									this.$vs.notify({
										time: 1000,
										title: 'Продажа выполнена успешно!',
										color: 'success',
										icon: 'close',
										position: 'top-right'
									});
									this.item = {}
									this.whItems = []
									this.items = []
									this.products = []
									this.productItems = []
									this.item = null
									this.realTotalSum = 0
									this.finalTotalSum = 0
									this.finalCount = 0
									this.checkTotalSum = 0
									this.kkmBtn = false
									this.kkmData = null
									this.disabled = false
									this.paymentModal = false
									this.dataForKKM = null
									this.createSale();
									this.$store.commit('pos/setIsReturn', false);
									this.$refs.multiPayModal.hide()
									this.closePayment();
									this.openClicked = false;
									this.loading = false
								} else {
									this.kkmBtn = true
									this.dataForKKM = {}
									this.dataForKKM.data = res.data
									this.dataForKKM.saleId = res.data.saleId
									this.$vs.notify({
										title: fisRes.data.error.message === 'ERROR_RECEIPT_MEMORY_FULL' ? 'Отправьте на сервер файлы чеков, получить RECEIPT_ACK и выполнить  INS_ASK_RECEIPT. Обращаться ККМщикам' :
											fisRes.data.error.message === 'ERROR_NOT_ENOUGH_CASH_FOR_REFUND' ||
												fisRes.data.error.message === 'ERROR_NOT_ENOUGH_CARD_FOR_REFUND' ||
												fisRes.data.error.message === 'ERROR_NOT_ENOUGH_VAT_FOR_REFUND' ? 'Не достаточно денег на кассе для возврата чека, попробуйте позже' :
												fisRes.data.error.message === 'ERROR_RECEIPT_CASH_OVERFLOW' ||
													fisRes.data.error.message === 'ERROR_RECEIPT_CARD_OVERFLOW' ||
													fisRes.data.error.message === 'ERROR_RECEIPT_COUNT_OVERFLOW' ||
													fisRes.data.error.message === 'ERROR_RECEIPT_VAT_OVERFLOW' ? 'Текущий Z-отчет переполнен операциями. Закройте и откройте Z-отчет и повторите попытку' :
													fisRes.data.error.message === 'ERROR_RECEIPT_STORE_DAYS_LIMIT_EXCEEDED' ? 'В ККМ имеются неотправленные чеки.' :
														fisRes.data.error.message === 'ERROR_RECEIPT_SEQ_OVERFLOW' ||
															fisRes.data.error.message === 'ERROR_NOT_INTIALIZED' ||
															fisRes.data.error.message === 'ERROR_ZREPORT_SPACE_IS_FULL' ||
															fisRes.data.error.message === 'ERROR_LOCKED_FOREVER' ? 'Сдать ККМ и получить новый' :
															fisRes.data.error.message === 'ERROR_RECEIPT_TIME_PAST' ||
																fisRes.data.error.message === 'ERROR_OPEN_ZREPORT_TIME_PAST' ||
																fisRes.data.error.message === 'ERROR_CLOSE_ZREPORT_TIME_PAST' ? 'Исправьте дату и время на моноблоке' :
																fisRes.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
																	fisRes.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
																	fisRes.data.error.message === 'ERROR_FRIST_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
																	fisRes.data.error.message === 'ERROR_LAST_TRANSACTION_TIME_FORMAT_INVALID' ||
																	fisRes.data.error.message === 'ERROR_ZREPORT_PARTITION_INVALID' ||
																	fisRes.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
																	fisRes.data.error.message === 'ERROR_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
																	fisRes.data.error.message === 'ERROR_RECEIPT_PARTITION_INVALID' ? 'Возможно ККМ поврежден. Обратиться к ККМщикам. Сдать ККМ и получить новый' :
																	fisRes.data.error.message === 'ERROR_ZREPORT_IS_ALREADY_OPEN' ? 'Z-отчет открыт. Обратиться к программистам' :
																		fisRes.data.error.message === 'ERROR_RECEIPT_FORMAT_INVALID' ||
																			fisRes.data.error.message === 'ERROR_OPEN_CLOSE_ZREPORT_WRONG_LENGTH' ||
																			fisRes.data.error.message === 'ERROR_CURRENT_TIME_FORMAT_INVALID' ||
																			fisRes.data.error.message === 'ERROR_LOCK_CHELLENGE_INVALID' ||
																			fisRes.data.error.message === 'ERROR_DATA_SIZE_NOT_SUPPORTED' ||
																			fisRes.data.error.message === 'ERROR_ACKNOWLEGE_WRONG_LENGTH' ||
																			fisRes.data.error.message === 'ERROR_ZREPORT_INDEX_OUT_OF_BOUNDS' ||
																			fisRes.data.error.message === 'ERROR_ACKNOWLEGE_TERMINAL_ID_MIS_MATCH' ||
																			fisRes.data.error.message === 'ERROR_ACKNOWLEGE_SIGNATURE_INVALID' ||
																			fisRes.data.error.message === 'SW_COMMAND_NOT_ALLOWED' ||
																			fisRes.data.error.message === 'ERROR_CONFIGURE_SIGNATURE_INVALID' ||
																			fisRes.data.error.message === 'ERROR_CONFIGURE_WRONG_LENGHT' ||
																			fisRes.data.error.message === 'SW_WRONG_P1P2' ||
																			fisRes.data.error.message === 'ERROR_RECEIPT_INDEX_OUT_OF_BOUNDS' ? 'Проверить Кассовое ПО на ошибки, исправить их и повторить попытку. Обратиться к ККМщикам' :
																			fisRes.data.error.message === 'ERROR_ZREPORT_IS_NOT_OPEN' ||
																				fisRes.data.error.message === 'ERROR_CURRENT_ZREPORT_IS_EMPTY' ||
																				fisRes.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
																				fisRes.data.error.message === 'ERROR_RECEIPT_COUNT_ZERO' ? 'Обратиться к ККМщикам: Ошибка Receipt Count Zero' :
																				fisRes.data.error.message,
										color: 'danger',
										icon: 'close',
										time: 50000,
										position: 'top-right'
									})
								}
							}).catch(e => {
								this.kkmBtn = true
								this.dataForKKM = {}
								this.dataForKKM.data = res.data
								this.dataForKKM.saleId = res.data.saleId
								this.loading = false
								if (e.request && e.request.response && e.request.response !== "") {
									let error = JSON.parse(e.request.response)
									this.$vs.notify({
										title: error.message || error.error.message,
										icon: 'close',
										color: 'danger',
										position: 'top-right'
									})
								} else {
									this.$vs.notify({
										title: e.message,
										icon: 'close',
										color: 'danger',
										position: 'top-right'
									})
								}
							})
						} else {
							this.$vs.notify({
								title: 'sale-finish error',
								color: 'danger',
								icon: 'close',
								time: 50000,
								position: 'top-right'
							})
						}
					}).catch(e => {
						this.loading = false
						if (e.request && e.request.response && e.request.response !== "") {
							this.$vs.notify({
								title: JSON.parse(e.request.response).message,
								icon: 'close',
								color: 'danger',
								position: 'top-right'
							})
						} else {
							this.$vs.notify({
								title: e.message,
								icon: 'close',
								color: 'danger',
								position: 'top-right'
							})
						}
					})
					// 	} else {
					// 		this.$vs.notify({
					// 			title: 'Пожалуйста, проверьте количество товаров',
					// 			color: 'danger',
					// 			icon: 'close',
					// 			time: 50000,
					// 			position: 'top-right'
					// 		});
					// 	}
					// }).catch(e => {
					// 	this.loading = false
					// 	this.$vs.notify({
					// 		title: e.message,
					// 		color: 'danger',
					// 		icon: 'close',
					// 		position: 'top-right'
					// 	})
					// 	this.$vs.notify({
					// 		title: 'Обновите браузер',
					// 		color: 'danger',
					// 		icon: 'close',
					// 		time: 50000,
					// 		position: 'top-right'
					// 	})
					// })
				} else {
					this.$vs.notify({
						title: 'Пожалуйста, добавьте продукт',
						color: 'warning',
						icon: 'close',
						time: 50000,
						position: 'top-right'
					});
				}
			} else {
				this.$vs.notify({
					title: 'Пожалуйста, выберите сотрудника',
					color: 'warning',
					icon: 'close',
					time: 50000,
					position: 'top-right'
				});
			}
			this.item = null
		},
		getCurrencyRates() {
			CurrencyService.fetchLastCurrencyRate().then(res => {
				this.lastCurrencyRates = res.data
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getSkyCurrencyRates(date) {
			CurrencyService.getCurrencyRatesForSky(date).then(res => {
				this.lastCurrencyRates = res.data
			}).catch(er => {
				this.$vs.notify({
					title: er.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		kkmModal() {
			this.getKkmSaleList();
			this.kkmSale = true
		},
		infoKkm() {
			this.loading = true
			FBoxService.getInfoFiscal().then(res => {
				this.loading = false
				if (res.data.is_success) {
					this.$vs.notify({
						title: 'ККМ работает!',
						color: 'success',
						icon: 'close',
						position: 'top-right'
					})
				} else {
					this.$vs.notify({
						title: this.$t('words.error'),
						text: 'ККМ не работает! Проверьте ККМ',
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					})
				}
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: this.$t('words.error'),
					text: 'ККМ не работает! Проверьте ККМ',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				})
			})
		},
		async payModal() {
			if (this.items.length > 0) {
				if (this.employeeId) {
					if (this.loading === false) {
						if (!this.skyShopSale)
							await this.getCurrencyRates();
						let can = true
						this.items.forEach(item => {
							if (item.count > item.qty)
								can = false
						})
						if (can) {
							this.barcodeDestroy();
							let cardList = []
							if (!this.skyShopSale) {
								await PosService.getCardList().then(res => {
									cardList = res.data
								}).catch(e => {
									this.$vs.notify({
										title: this.$t('words.error'),
										text: e.request ? (e.request.response ? JSON.parse(e.request.response).message : e.request) : e.message,
										color: 'danger',
										icon: 'close',
										position: 'top-right'
									})
								})
							}
							this.paymentCurrencyTypes = []
							let dataEur = null,
								dataUsd = null,
								dataRub = null,
								dataGbp = null,
								dataUzs = null;
							this.lastCurrencyRates.forEach((c, i) => {
								let tmp = {
									left: true,
									comment: '',
									code: c.currencyCode,
									rate: c.ratioToDepCurrencyRate,
									currencyId: c.currencyId,
									currencyRateId: c.id,
									paymentTypeCode: 'CASH',
									paymentTypeId: 60,
									value: 0
								}
								if (c.currencyCode === 'USD') {
									dataUsd = tmp
									let uzs = {
										left: true,
										comment: '',
										code: 'UZS',
										rate: c.rate,
										currencyId: 26,
										currencyRateId: null,
										paymentTypeCode: 'CASH',
										paymentTypeId: 60,
										value: 0
									}
									cardList.forEach(usd => {
										if (usd.code === 'UZCARD' || usd.code === 'HUMO' || usd.code === 'ONE_QR' || usd.code === 'CLICK' || usd.code === 'UZUM' || usd.code === 'PAYME') {
											let card = {
												left: false,
												comment: '',
												rate: c.rate,
												currencyId: 26,
												currencyRateId: null,
												paymentTypeCode: usd.code,
												paymentTypeId: usd.id,
												value: 0
											}
											this.paymentCurrencyTypes.push(card)
										}
									})
									dataUzs = uzs
								} else if (c.currencyCode === 'RUB') {
									dataRub = tmp
								} else if (c.currencyCode === 'GBP') {
									dataGbp = tmp
								} else if (c.currencyCode === 'EUR') {
									dataEur = tmp
								}
								cardList.forEach(usd => {
									if (c.currencyCode === 'USD') {
										if (usd.code === 'VISA') {
											let tmp1 = {
												left: false,
												comment: '',
												rate: c.ratioToDepCurrencyRate,
												currencyId: c.currencyId,
												currencyRateId: c.id,
												paymentTypeCode: usd.code,
												paymentTypeId: usd.id,
												value: 0
											}
											this.paymentCurrencyTypes.push(tmp1)
										}
									}
								})
							})
							this.paymentCurrencyTypes.push(dataEur);
							this.paymentCurrencyTypes.push(dataUsd);
							this.paymentCurrencyTypes.push(dataRub);
							this.paymentCurrencyTypes.push(dataGbp);
							this.paymentCurrencyTypes.push(dataUzs);
							console.log(this.paymentCurrencyTypes)
							this.checkTotalSum = this.finalTotalSum
							this.paymentModal = true
						} else {
							this.$vs.notify({
								title: 'Проверьте кол-во товаров',
								color: 'warning',
								icon: 'close',
								position: 'top-right'
							})
						}
					} else {
						this.$vs.notify({
							title: 'Loading ......',
							color: 'warning',
							icon: 'close',
							position: 'top-right'
						})
					}
				} else {
					this.$vs.notify({
						title: `Пожалуста выберите сотрудника !`,
						icon: 'close',
						time: 5000,
						color: 'warning',
						position: 'top-right'
					})
				}
			} else {
				this.$vs.notify({
					title: 'Нет товара в продаже',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				})
			}
		},
		async setCash(pay) {
			if (['UZCARD', 'HUMO', 'ONE_QR'].includes(pay.paymentTypeCode) && this.isNew === 'true' || ['UZUM', 'PAYME', 'CLICK'].includes(pay.paymentTypeCode)) {
				this.payItem = pay
				this.confirmModal = true
			} else {
				this.setAllCash(pay)
			}
		},
		setAllCash(pay) {
			if (this.checkTotalSum > 0) {
				if (pay.code === 'UZS' || pay.paymentTypeCode === 'UZCARD' || pay.paymentTypeCode === 'HUMO' || pay.paymentTypeCode === 'CLICK' || pay.paymentTypeCode === 'UZUM' || pay.paymentTypeCode === 'OSON' || pay.paymentTypeCode === 'PAYME' || pay.paymentTypeCode === 'ONE_QR')
					pay.value = (pay.value + this.roundUZS(this.checkTotalSum * pay.rate)).toFixed(2)
				else
					pay.value = (pay.value + (this.checkTotalSum * pay.rate)).toFixed(2)
				this.checkTotalSum = 0

				if ((['UZCARD', 'HUMO'].includes(pay.paymentTypeCode) && this.isNew === 'true') || pay.paymentTypeCode === 'ONE_QR') {
					this.paymentWithQrCode = pay.paymentTypeCode
					this.paymentPendingModal = true
					this.paymentAction(pay)
				}

				if (['UZUM', 'PAYME', 'CLICK'].includes(pay.paymentTypeCode)) {
					this.paymentWithQrCode = pay.paymentTypeCode
					this.paymentPendingModal = true
					this.barcodeInit()
				}
			}
		},
		clearCash(pay) {
			if (pay.value > 0) {
				this.checkTotalSum = this.checkTotalSum + (pay.value / pay.rate)
				pay.value = 0
				this.barcodeDestroy()
			}
		},
		calculatePayModal(pay, index) {
			this.calculateCount = ''
			this.calculateCount = pay.value === 0 ? '' : pay.value.toString()
			this.payIndex = index
			this.calculate = true
		},
		calculatePay() {
			if (this.calculateCount !== '') {
				let count = parseFloat(this.calculateCount).toFixed(2)
				if (this.paymentCurrencyTypes[this.payIndex].value === 0) {
					if (this.checkTotalSum >= (count / this.paymentCurrencyTypes[this.payIndex].rate)) {
						this.clearCash(this.paymentCurrencyTypes[this.payIndex])
						this.paymentCurrencyTypes[this.payIndex].value = count
						this.checkTotalSum = this.checkTotalSum - (count / this.paymentCurrencyTypes[this.payIndex].rate)
						this.calculate = false
					}
				} else {
					if (count <= (this.checkTotalSum + (this.paymentCurrencyTypes[this.payIndex].value / this.paymentCurrencyTypes[this.payIndex].rate))) {
						this.clearCash(this.paymentCurrencyTypes[this.payIndex])
						this.paymentCurrencyTypes[this.payIndex].value = count
						this.checkTotalSum = this.checkTotalSum - (count / this.paymentCurrencyTypes[this.payIndex].rate)
						this.calculate = false
					}
				}

				if (['UZCARD', 'HUMO', 'ONE_QR'].includes(this.paymentCurrencyTypes[this.payIndex].paymentTypeCode) && this.isNew === 'true') {
					this.paymentWithQrCode = this.paymentCurrencyTypes[this.payIndex].paymentTypeCode
					this.paymentPendingModal = true
					this.paymentAction(this.paymentCurrencyTypes[this.payIndex])
				}

				if (['UZUM', 'PAYME', 'CLICK'].includes(this.paymentCurrencyTypes[this.payIndex].paymentTypeCode)) {
					this.paymentWithQrCode = this.paymentCurrencyTypes[this.payIndex].paymentTypeCode
					this.paymentPendingModal = true
					this.barcodeInit()
				}
			}
		},
		saleItemsCount(count) {
			this.items.forEach(item => {
				count += item.count
			})
			return count;
		},
		async showLoaderForSaveSale() {
			this.loading = true
			await this.saveSale()
		},
		async saveSale() {
			this.loading = true
			if (this.saleForm.isDipShop ? this.saleForm.numberCard && this.saleForm.numberCard !== '' : this.saleForm.ticket && this.saleForm.ticket !== '') {
				if (this.checkTotalSum === 0) {
					this.barcodeDestroy();
					if (this.skyShopSale) {
						let payments = [];
						this.paymentCurrencyTypes.forEach(p => {
							if (p.value > 0) {
								payments.push(p)
							}
						})
						this.saleForm.warehouseDocumentId = this.skyShopDoc.id
						this.saleForm.brigadeId = this.skyShopDoc.brigadeId.id
						this.saleForm.saleDate = this.makeCurrentDateTime('savePos')
						this.saleForm.cashboxId = localStorage.getItem('cash_id')
						this.saleForm.cashboxNumber = localStorage.getItem('cash_number')
						this.saleForm.sellerId = this.employeeId.id
						this.saleForm.cashierFullName = `${this.employeeId.firstName} ${this.employeeId.lastName}`
						this.saleForm.customPromotion = null
						this.saleForm.finalTotalSum = this.finalTotalSum.toFixed(2)
						this.saleForm.realTotalSum = this.finalTotalSum.toFixed(2)
						this.saleForm.amountOfPaymentUzs = this.finalTotalSum.toFixed(2)
						this.saleForm.amountOfAfterPromoUzs = this.finalTotalSum.toFixed(2)
						this.saleForm.payments = payments
						this.saleForm.saleItems = this.items
						this.saleForm.passportInfoDto = this.identityList && this.identityList.name ? this.identityList : null
						this.saleForm.productItems = []
						this.saleForm.currencyRateDtos = this.lastCurrencyRates

						await PosService.finishSaleSky(this.saleForm).then(async (res) => {
							await FBoxService.orderCreate(localStorage.getItem('ip_address'), res.data, res.data.saleId).then(async (resFiscal) => {
								if (resFiscal.data.is_success) {
									// await this.saveSkyDoc(this.skyShopDoc.id);
									this.$vs.notify({
										time: 1000,
										title: 'Продажа выполнена успешно!',
										color: 'success',
										icon: 'close',
										position: 'top-right'
									});
									this.createSale();
									this.cancelSkyDocSale();
									this.kkmBtn = false
									this.kkmData = null
									this.disabled = false
									this.paymentModal = false
									this.saleConfirmModal = false
									this.loading = false
									this.barcodeInit();
								} else {
									this.kkmBtn = true
									this.dataForKKM = {}
									this.dataForKKM.data = res.data
									this.dataForKKM.saleId = res.data.saleId
									this.disabled = true
									this.saleConfirmModal = false
									this.loading = false
									this.$vs.notify({
										title: resFiscal.data.error.message,
										color: 'danger',
										icon: 'close',
										time: 50000,
										position: 'top-right'
									})
								}
							}).catch(e => {
								this.kkmBtn = true
								this.dataForKKM = {}
								this.dataForKKM.data = res.data
								this.dataForKKM.saleId = res.data.saleId
								this.disabled = true
								this.saleConfirmModal = false
								this.loading = false
								if (e.request && e.request.response && e.request.response !== "") {
									let error = JSON.parse(e.request.response)
									this.$vs.notify({
										title: error.message || error.error.message,
										icon: 'close',
										color: 'danger',
										position: 'top-right'
									})
								} else {
									this.$vs.notify({
										title: e.message,
										icon: 'close',
										color: 'danger',
										position: 'top-right'
									})
								}
							})
						}).catch(e => {
							this.loading = false
							this.saleConfirmModal = false
							if (e.request && e.request.response && e.request.response !== "") {
								this.$vs.notify({
									title: JSON.parse(e.request.response).message,
									icon: 'close',
									color: 'danger',
									position: 'top-right'
								})
							} else {
								this.$vs.notify({
									title: e.message,
									icon: 'close',
									color: 'danger',
									position: 'top-right'
								})
							}
						})
					} else {
						await CurrencyService.fetchLastCurrencyRate().then(async (resCur) => {
							if (resCur.data[0].id === this.lastCurrencyRates[0].id) {
								let payments = []
								this.paymentCurrencyTypes.forEach(p => {
									if (p.value > 0)
										payments.push(p)
								})
								this.saleForm.saleDate = this.makeCurrentDateTime('savePos')
								this.saleForm.cashboxId = localStorage.getItem('cash_id')
								this.saleForm.cashboxNumber = localStorage.getItem('cash_number')
								this.saleForm.sellerId = this.employeeId.id
								this.saleForm.cashierFullName = `${this.employeeId.firstName} ${this.employeeId.lastName}`
								this.saleForm.customPromotion = null
								this.saleForm.finalTotalSum = this.finalTotalSum.toFixed(2)
								this.saleForm.realTotalSum = this.finalTotalSum.toFixed(2)
								this.saleForm.amountOfPaymentUzs = this.finalTotalSum.toFixed(2)
								this.saleForm.amountOfAfterPromoUzs = this.finalTotalSum.toFixed(2)
								this.saleForm.payments = payments
								this.saleForm.saleItems = this.products
								this.saleForm.passportInfoDto = this.identityList && this.identityList.name ? this.identityList : null
								this.saleForm.productItems = this.productItems
								this.saleForm.currencyRateDtos = resCur.data
								await PosService.finishSale(this.saleForm, this.isBar).then(async (res) => {
									await FBoxService.orderCreate(localStorage.getItem('ip_address'), res.data, res.data.saleId).then(resFiscal => {
										if (resFiscal.data.is_success) {
											this.$vs.notify({
												time: 1000,
												title: 'Продажа выполнена успешно!',
												color: 'success',
												icon: 'close',
												position: 'top-right'
											});
											this.createSale();
											this.item = {}
											this.whItems = []
											this.items = []
											this.products = []
											this.productItems = []
											this.item = null
											this.realTotalSum = 0
											this.finalTotalSum = 0
											this.finalCount = 0
											this.checkTotalSum = 0
											this.kkmBtn = false
											this.kkmData = null
											this.disabled = false
											this.paymentModal = false
											this.loading = false
											this.saleConfirmModal = false
											this.barcodeInit();
										} else {
											this.kkmBtn = true
											this.dataForKKM = {}
											this.dataForKKM.data = res.data
											this.dataForKKM.saleId = res.data.saleId
											this.disabled = true
											this.loading = false
											this.saleConfirmModal = false
											this.$vs.notify({
												title: resFiscal.data.error.message === 'ERROR_RECEIPT_MEMORY_FULL' ? 'Отправьте на сервер файлы чеков, получить RECEIPT_ACK и выполнить  INS_ASK_RECEIPT. Обращаться ККМщикам' :
													resFiscal.data.error.message === 'ERROR_NOT_ENOUGH_CASH_FOR_REFUND' ||
														resFiscal.data.error.message === 'ERROR_NOT_ENOUGH_CARD_FOR_REFUND' ||
														resFiscal.data.error.message === 'ERROR_NOT_ENOUGH_VAT_FOR_REFUND' ? 'Не достаточно денег на кассе для возврата чека, попробуйте позже' :
														resFiscal.data.error.message === 'ERROR_RECEIPT_CASH_OVERFLOW' ||
															resFiscal.data.error.message === 'ERROR_RECEIPT_CARD_OVERFLOW' ||
															resFiscal.data.error.message === 'ERROR_RECEIPT_COUNT_OVERFLOW' ||
															resFiscal.data.error.message === 'ERROR_RECEIPT_VAT_OVERFLOW' ? 'Текущий Z-отчет переполнен операциями. Закройте и откройте Z-отчет и повторите попытку' :
															resFiscal.data.error.message === 'ERROR_RECEIPT_STORE_DAYS_LIMIT_EXCEEDED' ? 'В ККМ имеются неотправленные чеки.' :
																resFiscal.data.error.message === 'ERROR_RECEIPT_SEQ_OVERFLOW' ||
																	resFiscal.data.error.message === 'ERROR_NOT_INTIALIZED' ||
																	resFiscal.data.error.message === 'ERROR_ZREPORT_SPACE_IS_FULL' ||
																	resFiscal.data.error.message === 'ERROR_LOCKED_FOREVER' ? 'Сдать ККМ и получить новый' :
																	resFiscal.data.error.message === 'ERROR_RECEIPT_TIME_PAST' ||
																		resFiscal.data.error.message === 'ERROR_OPEN_ZREPORT_TIME_PAST' ||
																		resFiscal.data.error.message === 'ERROR_CLOSE_ZREPORT_TIME_PAST' ? 'Исправить дату и времия на моноблоке и повторить попытку' :
																		resFiscal.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
																			resFiscal.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_FRIST_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_LAST_TRANSACTION_TIME_FORMAT_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_ZREPORT_PARTITION_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_ZREPORT_OPEN_TIME_FORMAT_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_RECEIPIT_TRANSACTION_TIME_FORMAT_INVALID' ||
																			resFiscal.data.error.message === 'ERROR_RECEIPT_PARTITION_INVALID' ? 'Возможно ККМ поврежден. Обратиться к ККМщикам. Сдать ККМ и получить новый' :
																			resFiscal.data.error.message === 'ERROR_ZREPORT_IS_ALREADY_OPEN' ? 'Z-отчет открыт. Обновите страницы и перезагрузите ККМ' :
																				resFiscal.data.error.message === 'ERROR_RECEIPT_FORMAT_INVALID' ||
																					resFiscal.data.error.message === 'ERROR_OPEN_CLOSE_ZREPORT_WRONG_LENGTH' ||
																					resFiscal.data.error.message === 'ERROR_CURRENT_TIME_FORMAT_INVALID' ||
																					resFiscal.data.error.message === 'ERROR_LOCK_CHELLENGE_INVALID' ||
																					resFiscal.data.error.message === 'ERROR_DATA_SIZE_NOT_SUPPORTED' ||
																					resFiscal.data.error.message === 'ERROR_ACKNOWLEGE_WRONG_LENGTH' ||
																					resFiscal.data.error.message === 'ERROR_ZREPORT_INDEX_OUT_OF_BOUNDS' ||
																					resFiscal.data.error.message === 'ERROR_ACKNOWLEGE_TERMINAL_ID_MIS_MATCH' ||
																					resFiscal.data.error.message === 'ERROR_ACKNOWLEGE_SIGNATURE_INVALID' ||
																					resFiscal.data.error.message === 'SW_COMMAND_NOT_ALLOWED' ||
																					resFiscal.data.error.message === 'ERROR_CONFIGURE_SIGNATURE_INVALID' ||
																					resFiscal.data.error.message === 'ERROR_CONFIGURE_WRONG_LENGHT' ||
																					resFiscal.data.error.message === 'SW_WRONG_P1P2' ||
																					resFiscal.data.error.message === 'ERROR_RECEIPT_INDEX_OUT_OF_BOUNDS' ? 'Проверить Кассовое ПО на ошибки, исправить их и повторить попытку' :
																					resFiscal.data.error.message === 'ERROR_ZREPORT_IS_NOT_OPEN' ||
																						resFiscal.data.error.message === 'ERROR_CURRENT_ZREPORT_IS_EMPTY' ||
																						resFiscal.data.error.message === 'ERROR_RECEIPT_NOT_FOUND' ||
																						resFiscal.data.error.message === 'ERROR_RECEIPT_COUNT_ZERO' ? 'Ошибка в Z отчет:' : resFiscal.data.error.message,
												color: 'danger',
												icon: 'close',
												time: 50000,
												position: 'top-right'
											})
										}
									}).catch(e => {
										this.kkmBtn = true
										this.dataForKKM = {}
										this.dataForKKM.data = res.data
										this.dataForKKM.saleId = res.data.saleId
										this.disabled = true
										this.loading = false
										this.saleConfirmModal = false
										if (e.request && e.request.response && e.request.response !== "") {
											let error = JSON.parse(e.request.response)
											this.$vs.notify({
												title: error.message || error.error.message,
												icon: 'close',
												color: 'danger',
												position: 'top-right'
											})
										} else {
											this.$vs.notify({
												title: e.message,
												icon: 'close',
												color: 'danger',
												position: 'top-right'
											})
										}
									})
								}).catch(e => {
									this.loading = false
									this.saleConfirmModal = false
									if (e.request && e.request.response && e.request.response !== "") {
										this.$vs.notify({
											title: JSON.parse(e.request.response).message,
											icon: 'close',
											color: 'danger',
											position: 'top-right'
										})
									} else {
										this.$vs.notify({
											title: e.message,
											icon: 'close',
											color: 'danger',
											position: 'top-right'
										})
									}
								})
							} else {
								this.$vs.notify({
									title: `Курс обновился, пожалуйста обновите браузер`,
									icon: 'close',
									color: 'warning',
									time: 50000,
									position: 'top-right'
								})
							}
						}).catch(e => {
							this.loading = false
							this.saleConfirmModal = false
							if (e.request && e.request.response && e.request.response !== "") {
								this.$vs.notify({
									title: JSON.parse(e.request.response).message,
									icon: 'close',
									color: 'danger',
									position: 'top-right'
								})
							} else {
								this.$vs.notify({
									title: e.message,
									icon: 'close',
									color: 'danger',
									position: 'top-right'
								})
							}
						})
					}
				} else {
					this.saleConfirmModal = false
					this.$vs.notify({
						title: `Пожалуйста правильно вычислите деньги!`,
						icon: 'close',
						color: 'warning',
						time: 50000,
						position: 'top-right'
					})
				}
			}
			else {
				if (this.saleForm.isDipShop) {
					this.saleConfirmModal = false
					this.$vs.notify({
						title: `Заполняйте поле Номер карточки!`,
						icon: 'close',
						color: 'danger',
						time: 5000,
						position: 'top-right'
					})
				}
				else {
					this.saleConfirmModal = false
					this.$vs.notify({
						title: `Заполняйте поле билет!`,
						icon: 'close',
						color: 'danger',
						time: 5000,
						position: 'top-right'
					})
				}
			}
			this.loading = false;
		},
		async saveSkyDoc(id) {
			await SkyShopService.saveReadyDoc(id).then(res => { }).catch(e => {
				this.$vs.notify({
					title: e.message,
					icon: 'close',
					color: 'danger',
					position: 'top-right'
				})
			})
		},
		barcodeDestroy() {
			this.$barcodeScanner.destroy();
		},
		barcodeInit() {
			this.$barcodeScanner.init(this.posBarcodeScanned);
		},
		groupPhoto(item) {
			if (item.photoId) {
				return `${this.imageUrl + item.photoId}`
			} else {
				return `${this.publicPath}img/item.png`
			}
		},
		async getGroupList() {
			this.loading = true
			await groupService.getListForPos().then(res => {
				this.groupOrProduct = true
				this.loading = false
				this.groupList = res.data
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getProductsByGroup(group) {
			this.loading = true
			ProductService.getListByGroup(group.id, localStorage.getItem('dep_id')).then(res => {
				if (res.data) {
					this.productList = res.data
					this.groupOrProduct = false
					this.loading = false
				}
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		getSkyShopList() {
			this.loading = true
			SkyShopService.getDocList().then(res => {
				this.skyShopDocList = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		createSkyItems(doc) {
			this.loading = true
			SkyShopService.getDocByIdForPos(doc.id).then(res => {
				this.skyShopDoc = res.data
				this.whItems = res.data.whItems
				this.viewSkyDocItems = res.data.whItems
				this.getSkyCurrencyRates(res.data.regDate);
				this.skyShopTable = false
				this.skyShopSale = true
				this.loading = false
				this.$forceUpdate()
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		cancelSkyDocSale() {
			this.item = {}
			this.whItems = []
			this.items = []
			this.products = []
			this.productItems = []
			this.item = null
			this.realTotalSum = 0
			this.finalTotalSum = 0
			this.finalCount = 0
			this.checkTotalSum = 0
			this.skyShopDoc = {}
			this.viewSkyDocItems = []
			this.skyShopSale = false
			this.skyShopTable = true
			this.getCurrencyRates();
			this.getSkyShopList();
			this.$forceUpdate();
		},
		viewSkyItems(doc) {
			SkyShopService.getDocByIdForPos(doc.id).then(res => {
				this.skyShopDoc = res.data
				this.viewSkyDocItems = res.data.whItems
				this.viewItemsSkyModal = true
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		productInfoTrue(item) {
			this.product = item
			this.productInfoModal = true
		},
		canSale(item) {
			if (item && item.whItems && item.whItems.length > 0) {
				let can = true
				item.whItems.forEach(t => {
					if (!t.qty)
						can = false
				})
				return can
			} else {
				return false
			}
		},
		addProduct() {
			if (this.canSale(this.product)) {
				let item = {},
					index = null,
					can = true;
				this.productItems.forEach((t, i) => {
					if (t.id === this.product.id) {
						can = false
						item = t
						index = i
					}
				})
				let tmpIndex = null;
				this.items.forEach((t, i) => {
					if (t.id === this.product.id) {
						tmpIndex = i
					}
					t._rowVariant = ''
				})
				if (can) {
					this.product.saleItems = this.product.whItems
					this.product.priceUzs = this.product.totalPrices
					this.product.productId = this.product.id
					this.product.saleId = this.saleForm.id
					this.product.count = 1
					this.product.isBar = true
					this.product._rowVariant = 'primary'
					this.productItems.unshift(this.product)
					this.items.unshift(this.product)
					this.selectedItem = this.product
					this.selectedItemIndex = 0
				} else {
					this.items.splice(tmpIndex, 1);
					this.productItems.splice(index, 1);
					item._rowVariant = 'primary'
					this.productItems.unshift(item)
					this.items.unshift(item)
					this.selectedItem = item
					this.selectedItemIndex = 0
				}
				let sum = 0,
					fin = 0,
					co = 0;
				this.items.forEach(t => {
					sum += (t.count * t.priceUzs)
					fin += (t.count * (t.discountPriceUzs ? t.discountPriceUzs : t.priceUzs))
					co += t.count
				})
				this.realTotalSum = sum
				this.finalTotalSum = fin
				this.totalCount = co
				this.$forceUpdate();
				this.productInfoModal = false
				this.restaurantProductModal = false
			}
		}
	},
	async created() {
		this.loading = true
		await this.getEmployees('');
		await this.getCurrencyRates();
		await this.createSale();
		await this.getKkmSaleCount();
		if (this.isBar)
			await this.getGroupList();
		else if (this.isSkyShop && this.$route.query.docId) {
			SkyShopService.getDocByIdForPos(this.$route.query.docId).then(res => {
				this.skyShopDoc = res.data
				this.whItems = res.data.whItems
				this.viewSkyDocItems = res.data.whItems
				this.getSkyCurrencyRates(res.data.regDate);
				this.skyShopTable = false
				this.skyShopSale = true
				this.$forceUpdate()
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		}
		this.$barcodeScanner.init(this.posBarcodeScanned);
		this.loading = false
	}
}
</script>

<style scoped>
.bg-light-blue {
	background-color: #96c1ff !important;
}

.bg-grey {
	background-color: #eaeaea;
}

.bg-red {
	background-color: #ff3e3e;
}

.badge-btn {
	padding: 12px;
	font-size: 15px;
}

.focus-out:focus {
	outline: none;
	box-shadow: none;
}

.countInput output bdi {
	font-size: 13px;
	font-weight: bold;
}

.loader {
	width: 8px;
	height: 40px;
	border-radius: 4px;
	display: block;
	margin: 20px auto;
	position: relative;
	background: currentColor;
	color: #006C9C;
	box-sizing: border-box;
	animation: animloader 0.5s 0.5s linear infinite alternate;
}

.loader::after,
.loader::before {
	content: '';
	width: 8px;
	height: 40px;
	border-radius: 4px;
	background: currentColor;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 20px;
	box-sizing: border-box;
	animation: animloader 0.5s 0.65s linear infinite alternate;
}

.loader::before {
	left: -20px;
	animation-delay: 0s;
}

@keyframes animloader {
	0% {
		height: 48px
	}

	100% {
		height: 4px
	}
}
</style>
